import _toConsumableArray from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _possibleConstructorReturn from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _get from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/get";
import _getPrototypeOf from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/inherits";
import _regeneratorRuntime from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/regenerator";
import _classCallCheck from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/circleci/repo/front/node_modules/react-scripts/node_modules/@babel/runtime/helpers/esm/createClass";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e59) { throw _e59; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e60) { didErr = true; err = _e60; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/*!
 * Dynamsoft JavaScript Library
 * @product Dynamsoft Barcode Reader JS Edition
 * @website http://www.dynamsoft.com
 * @copyright Copyright 2022, Dynamsoft Corporation
 * @author Dynamsoft
 * @version 8.8.7 (js 20220125)
 * @fileoverview Dynamsoft JavaScript Library for Barcode Reader
 * More info on DBR JS: https://www.dynamsoft.com/barcode-reader/sdk-javascript/
 */
import e, { CameraEnhancer as t } from "dynamsoft-camera-enhancer";
export { default as CameraEnhancer } from "dynamsoft-camera-enhancer";

function i(e, t, i, n) {
  return new (i || (i = Promise))(function (r, s) {
    function o(e) {
      try {
        d(n.next(e));
      } catch (e) {
        s(e);
      }
    }

    function a(e) {
      try {
        d(n.throw(e));
      } catch (e) {
        s(e);
      }
    }

    function d(e) {
      var t;
      e.done ? r(e.value) : (t = e.value, t instanceof i ? t : new i(function (e) {
        e(t);
      })).then(o, a);
    }

    d((n = n.apply(e, t || [])).next());
  });
}

var n, r, s, o;
!function (e) {
  e[e.IPF_Binary = 0] = "IPF_Binary", e[e.IPF_BinaryInverted = 1] = "IPF_BinaryInverted", e[e.IPF_GrayScaled = 2] = "IPF_GrayScaled", e[e.IPF_NV21 = 3] = "IPF_NV21", e[e.IPF_RGB_565 = 4] = "IPF_RGB_565", e[e.IPF_RGB_555 = 5] = "IPF_RGB_555", e[e.IPF_RGB_888 = 6] = "IPF_RGB_888", e[e.IPF_ARGB_8888 = 7] = "IPF_ARGB_8888", e[e.IPF_RGB_161616 = 8] = "IPF_RGB_161616", e[e.IPF_ARGB_16161616 = 9] = "IPF_ARGB_16161616", e[e.IPF_ABGR_8888 = 10] = "IPF_ABGR_8888", e[e.IPF_ABGR_16161616 = 11] = "IPF_ABGR_16161616", e[e.IPF_BGR_888 = 12] = "IPF_BGR_888";
}(n || (n = {})), function (e) {
  e[e.DBR_SYSTEM_EXCEPTION = 1] = "DBR_SYSTEM_EXCEPTION", e[e.DBR_SUCCESS = 0] = "DBR_SUCCESS", e[e.DBR_UNKNOWN = -1e4] = "DBR_UNKNOWN", e[e.DBR_NO_MEMORY = -10001] = "DBR_NO_MEMORY", e[e.DBR_NULL_REFERENCE = -10002] = "DBR_NULL_REFERENCE", e[e.DBR_LICENSE_INVALID = -10003] = "DBR_LICENSE_INVALID", e[e.DBR_LICENSE_EXPIRED = -10004] = "DBR_LICENSE_EXPIRED", e[e.DBR_FILE_NOT_FOUND = -10005] = "DBR_FILE_NOT_FOUND", e[e.DBR_FILETYPE_NOT_SUPPORTED = -10006] = "DBR_FILETYPE_NOT_SUPPORTED", e[e.DBR_BPP_NOT_SUPPORTED = -10007] = "DBR_BPP_NOT_SUPPORTED", e[e.DBR_INDEX_INVALID = -10008] = "DBR_INDEX_INVALID", e[e.DBR_BARCODE_FORMAT_INVALID = -10009] = "DBR_BARCODE_FORMAT_INVALID", e[e.DBR_CUSTOM_REGION_INVALID = -10010] = "DBR_CUSTOM_REGION_INVALID", e[e.DBR_MAX_BARCODE_NUMBER_INVALID = -10011] = "DBR_MAX_BARCODE_NUMBER_INVALID", e[e.DBR_IMAGE_READ_FAILED = -10012] = "DBR_IMAGE_READ_FAILED", e[e.DBR_TIFF_READ_FAILED = -10013] = "DBR_TIFF_READ_FAILED", e[e.DBR_QR_LICENSE_INVALID = -10016] = "DBR_QR_LICENSE_INVALID", e[e.DBR_1D_LICENSE_INVALID = -10017] = "DBR_1D_LICENSE_INVALID", e[e.DBR_DIB_BUFFER_INVALID = -10018] = "DBR_DIB_BUFFER_INVALID", e[e.DBR_PDF417_LICENSE_INVALID = -10019] = "DBR_PDF417_LICENSE_INVALID", e[e.DBR_DATAMATRIX_LICENSE_INVALID = -10020] = "DBR_DATAMATRIX_LICENSE_INVALID", e[e.DBR_PDF_READ_FAILED = -10021] = "DBR_PDF_READ_FAILED", e[e.DBR_PDF_DLL_MISSING = -10022] = "DBR_PDF_DLL_MISSING", e[e.DBR_PAGE_NUMBER_INVALID = -10023] = "DBR_PAGE_NUMBER_INVALID", e[e.DBR_CUSTOM_SIZE_INVALID = -10024] = "DBR_CUSTOM_SIZE_INVALID", e[e.DBR_CUSTOM_MODULESIZE_INVALID = -10025] = "DBR_CUSTOM_MODULESIZE_INVALID", e[e.DBR_RECOGNITION_TIMEOUT = -10026] = "DBR_RECOGNITION_TIMEOUT", e[e.DBR_JSON_PARSE_FAILED = -10030] = "DBR_JSON_PARSE_FAILED", e[e.DBR_JSON_TYPE_INVALID = -10031] = "DBR_JSON_TYPE_INVALID", e[e.DBR_JSON_KEY_INVALID = -10032] = "DBR_JSON_KEY_INVALID", e[e.DBR_JSON_VALUE_INVALID = -10033] = "DBR_JSON_VALUE_INVALID", e[e.DBR_JSON_NAME_KEY_MISSING = -10034] = "DBR_JSON_NAME_KEY_MISSING", e[e.DBR_JSON_NAME_VALUE_DUPLICATED = -10035] = "DBR_JSON_NAME_VALUE_DUPLICATED", e[e.DBR_TEMPLATE_NAME_INVALID = -10036] = "DBR_TEMPLATE_NAME_INVALID", e[e.DBR_JSON_NAME_REFERENCE_INVALID = -10037] = "DBR_JSON_NAME_REFERENCE_INVALID", e[e.DBR_PARAMETER_VALUE_INVALID = -10038] = "DBR_PARAMETER_VALUE_INVALID", e[e.DBR_DOMAIN_NOT_MATCHED = -10039] = "DBR_DOMAIN_NOT_MATCHED", e[e.DBR_RESERVEDINFO_NOT_MATCHED = -10040] = "DBR_RESERVEDINFO_NOT_MATCHED", e[e.DBR_AZTEC_LICENSE_INVALID = -10041] = "DBR_AZTEC_LICENSE_INVALID", e[e.DBR_LICENSE_DLL_MISSING = -10042] = "DBR_LICENSE_DLL_MISSING", e[e.DBR_LICENSEKEY_NOT_MATCHED = -10043] = "DBR_LICENSEKEY_NOT_MATCHED", e[e.DBR_REQUESTED_FAILED = -10044] = "DBR_REQUESTED_FAILED", e[e.DBR_LICENSE_INIT_FAILED = -10045] = "DBR_LICENSE_INIT_FAILED", e[e.DBR_PATCHCODE_LICENSE_INVALID = -10046] = "DBR_PATCHCODE_LICENSE_INVALID", e[e.DBR_POSTALCODE_LICENSE_INVALID = -10047] = "DBR_POSTALCODE_LICENSE_INVALID", e[e.DBR_DPM_LICENSE_INVALID = -10048] = "DBR_DPM_LICENSE_INVALID", e[e.DBR_FRAME_DECODING_THREAD_EXISTS = -10049] = "DBR_FRAME_DECODING_THREAD_EXISTS", e[e.DBR_STOP_DECODING_THREAD_FAILED = -10050] = "DBR_STOP_DECODING_THREAD_FAILED", e[e.DBR_SET_MODE_ARGUMENT_ERROR = -10051] = "DBR_SET_MODE_ARGUMENT_ERROR", e[e.DBR_LICENSE_CONTENT_INVALID = -10052] = "DBR_LICENSE_CONTENT_INVALID", e[e.DBR_LICENSE_KEY_INVALID = -10053] = "DBR_LICENSE_KEY_INVALID", e[e.DBR_LICENSE_DEVICE_RUNS_OUT = -10054] = "DBR_LICENSE_DEVICE_RUNS_OUT", e[e.DBR_GET_MODE_ARGUMENT_ERROR = -10055] = "DBR_GET_MODE_ARGUMENT_ERROR", e[e.DBR_IRT_LICENSE_INVALID = -10056] = "DBR_IRT_LICENSE_INVALID", e[e.DBR_MAXICODE_LICENSE_INVALID = -10057] = "DBR_MAXICODE_LICENSE_INVALID", e[e.DBR_GS1_DATABAR_LICENSE_INVALID = -10058] = "DBR_GS1_DATABAR_LICENSE_INVALID", e[e.DBR_GS1_COMPOSITE_LICENSE_INVALID = -10059] = "DBR_GS1_COMPOSITE_LICENSE_INVALID", e[e.DBR_DOTCODE_LICENSE_INVALID = -10061] = "DBR_DOTCODE_LICENSE_INVALID", e[e.DMERR_NO_LICENSE = -2e4] = "DMERR_NO_LICENSE", e[e.DMERR_LICENSE_SYNC_FAILED = -20003] = "DMERR_LICENSE_SYNC_FAILED", e[e.DMERR_TRIAL_LICENSE = -20010] = "DMERR_TRIAL_LICENSE", e[e.DMERR_FAILED_TO_REACH_LTS = -20200] = "DMERR_FAILED_TO_REACH_LTS";
}(r || (r = {})), function (e) {
  e[e.IMRDT_IMAGE = 1] = "IMRDT_IMAGE", e[e.IMRDT_CONTOUR = 2] = "IMRDT_CONTOUR", e[e.IMRDT_LINESEGMENT = 4] = "IMRDT_LINESEGMENT", e[e.IMRDT_LOCALIZATIONRESULT = 8] = "IMRDT_LOCALIZATIONRESULT", e[e.IMRDT_REGIONOFINTEREST = 16] = "IMRDT_REGIONOFINTEREST", e[e.IMRDT_QUADRILATERAL = 32] = "IMRDT_QUADRILATERAL";
}(s || (s = {})), function (e) {
  e[e.BF_ALL = -31457281] = "BF_ALL", e[e.BF_ONED = 1050623] = "BF_ONED", e[e.BF_GS1_DATABAR = 260096] = "BF_GS1_DATABAR", e[e.BF_CODE_39 = 1] = "BF_CODE_39", e[e.BF_CODE_128 = 2] = "BF_CODE_128", e[e.BF_CODE_93 = 4] = "BF_CODE_93", e[e.BF_CODABAR = 8] = "BF_CODABAR", e[e.BF_ITF = 16] = "BF_ITF", e[e.BF_EAN_13 = 32] = "BF_EAN_13", e[e.BF_EAN_8 = 64] = "BF_EAN_8", e[e.BF_UPC_A = 128] = "BF_UPC_A", e[e.BF_UPC_E = 256] = "BF_UPC_E", e[e.BF_INDUSTRIAL_25 = 512] = "BF_INDUSTRIAL_25", e[e.BF_CODE_39_EXTENDED = 1024] = "BF_CODE_39_EXTENDED", e[e.BF_GS1_DATABAR_OMNIDIRECTIONAL = 2048] = "BF_GS1_DATABAR_OMNIDIRECTIONAL", e[e.BF_GS1_DATABAR_TRUNCATED = 4096] = "BF_GS1_DATABAR_TRUNCATED", e[e.BF_GS1_DATABAR_STACKED = 8192] = "BF_GS1_DATABAR_STACKED", e[e.BF_GS1_DATABAR_STACKED_OMNIDIRECTIONAL = 16384] = "BF_GS1_DATABAR_STACKED_OMNIDIRECTIONAL", e[e.BF_GS1_DATABAR_EXPANDED = 32768] = "BF_GS1_DATABAR_EXPANDED", e[e.BF_GS1_DATABAR_EXPANDED_STACKED = 65536] = "BF_GS1_DATABAR_EXPANDED_STACKED", e[e.BF_GS1_DATABAR_LIMITED = 131072] = "BF_GS1_DATABAR_LIMITED", e[e.BF_PATCHCODE = 262144] = "BF_PATCHCODE", e[e.BF_PDF417 = 33554432] = "BF_PDF417", e[e.BF_QR_CODE = 67108864] = "BF_QR_CODE", e[e.BF_DATAMATRIX = 134217728] = "BF_DATAMATRIX", e[e.BF_AZTEC = 268435456] = "BF_AZTEC", e[e.BF_MAXICODE = 536870912] = "BF_MAXICODE", e[e.BF_MICRO_QR = 1073741824] = "BF_MICRO_QR", e[e.BF_MICRO_PDF417 = 524288] = "BF_MICRO_PDF417", e[e.BF_GS1_COMPOSITE = -2147483648] = "BF_GS1_COMPOSITE", e[e.BF_MSI_CODE = 1048576] = "BF_MSI_CODE", e[e.BF_NULL = 0] = "BF_NULL";
}(o || (o = {})), "object" == typeof global && global.process && global.process.release && global.process.release.name;
var a = "undefined" == typeof self,
    d = a ? {} : self;

var _ = /*#__PURE__*/function () {
  function _() {
    _classCallCheck(this, _);

    this._canvasMaxWH = "iPhone" == _.browserInfo.OS || "Android" == _.browserInfo.OS ? 2048 : 4096, this._instanceID = void 0, this.bSaveOriCanvas = !1, this.oriCanvas = null, this.bFilterRegionInJs = !0, this._region = null, this._timeStartDecode = null, this._timeEnterInnerDBR = null, this._timeGetMessage = null, this._bUseWebgl = !0, this.decodeRecords = {}, this.bDestroyed = !1, this._lastErrorCode = 0, this._lastErrorString = "", this._lastInnerDecodeDuration = 0;
  }

  _createClass(_, [{
    key: "getOriginalImageInACanvas",
    value: function getOriginalImageInACanvas() {
      return this.oriCanvas;
    }
  }, {
    key: "isContextDestroyed",
    value: function isContextDestroyed() {
      return this.bDestroyed;
    }
  }, {
    key: "decode",
    value: function decode(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _t;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _._onLog && _._onLog("decode(source: any)"), _._onLog && (this._timeStartDecode = Date.now());
                _t = {};
                !this.region || this.region instanceof Array || (_t.region = JSON.parse(JSON.stringify(this.region)));

                if (!(e instanceof Blob)) {
                  _context.next = 9;
                  break;
                }

                _context.next = 6;
                return this._decode_Blob(e, _t);

              case 6:
                _context.t0 = _context.sent;
                _context.next = 61;
                break;

              case 9:
                if (!(e instanceof ArrayBuffer)) {
                  _context.next = 15;
                  break;
                }

                _context.next = 12;
                return this._decode_ArrayBuffer(e, _t);

              case 12:
                _context.t1 = _context.sent;
                _context.next = 60;
                break;

              case 15:
                if (!(e instanceof Uint8Array || e instanceof Uint8ClampedArray)) {
                  _context.next = 21;
                  break;
                }

                _context.next = 18;
                return this._decode_Uint8Array(e, _t);

              case 18:
                _context.t2 = _context.sent;
                _context.next = 59;
                break;

              case 21:
                if (!(e instanceof HTMLImageElement || "undefined" != typeof ImageBitmap && e instanceof ImageBitmap)) {
                  _context.next = 27;
                  break;
                }

                _context.next = 24;
                return this._decode_Image(e, _t);

              case 24:
                _context.t3 = _context.sent;
                _context.next = 58;
                break;

              case 27:
                if (!(e instanceof HTMLCanvasElement || "undefined" != typeof OffscreenCanvas && e instanceof OffscreenCanvas)) {
                  _context.next = 33;
                  break;
                }

                _context.next = 30;
                return this._decode_Canvas(e, _t);

              case 30:
                _context.t4 = _context.sent;
                _context.next = 57;
                break;

              case 33:
                if (!(e instanceof HTMLVideoElement)) {
                  _context.next = 39;
                  break;
                }

                _context.next = 36;
                return this._decode_Video(e, _t);

              case 36:
                _context.t5 = _context.sent;
                _context.next = 56;
                break;

              case 39:
                if (!("string" == typeof e)) {
                  _context.next = 52;
                  break;
                }

                if (!("data:image/" == e.substring(0, 11))) {
                  _context.next = 46;
                  break;
                }

                _context.next = 43;
                return this._decode_Base64(e, _t);

              case 43:
                _context.t7 = _context.sent;
                _context.next = 49;
                break;

              case 46:
                _context.next = 48;
                return this._decode_Url(e, _t);

              case 48:
                _context.t7 = _context.sent;

              case 49:
                _context.t6 = _context.t7;
                _context.next = 55;
                break;

              case 52:
                _context.next = 54;
                return Promise.reject(TypeError("'_decode(source, config)': Type of 'source' should be 'Blob', 'ArrayBuffer', 'Uint8Array', 'HTMLImageElement', 'HTMLCanvasElement', 'HTMLVideoElement', 'String(base64 with image mime)' or 'String(url)'."));

              case 54:
                _context.t6 = _context.sent;

              case 55:
                _context.t5 = _context.t6;

              case 56:
                _context.t4 = _context.t5;

              case 57:
                _context.t3 = _context.t4;

              case 58:
                _context.t2 = _context.t3;

              case 59:
                _context.t1 = _context.t2;

              case 60:
                _context.t0 = _context.t1;

              case 61:
                return _context.abrupt("return", _context.t0);

              case 62:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "decodeBase64String",
    value: function decodeBase64String(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var t;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                t = {};
                return _context2.abrupt("return", (!this.region || this.region instanceof Array || (t.region = JSON.parse(JSON.stringify(this.region))), this._decode_Base64(e, t)));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
    }
  }, {
    key: "decodeUrl",
    value: function decodeUrl(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var t;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                t = {};
                return _context3.abrupt("return", (!this.region || this.region instanceof Array || (t.region = JSON.parse(JSON.stringify(this.region))), this._decode_Url(e, t)));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "_decodeBuffer_Uint8Array",
    value: function _decodeBuffer_Uint8Array(e, t, n, r, s, o) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var _this = this;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return new Promise(function (i, a) {
                  var d = _._nextTaskID++;
                  _._taskCallbackMap.set(d, function (e) {
                    if (e.success) {
                      var _t2,
                          _n = _._onLog ? Date.now() : 0;

                      _._onLog && _._onLog("worker return result: " + _n), _this._lastInnerDecodeDuration = e.duration;

                      try {
                        _t2 = _this._handleRetJsonString(e.decodeReturn);
                      } catch (e) {
                        return a(e);
                      }

                      if (_._onLog) {
                        var _e = Date.now();

                        _._onLog("DBR time get result: " + _n), _._onLog("Handle image cost: " + (_this._timeEnterInnerDBR - _this._timeStartDecode)), _._onLog("DBR worker decode image cost: " + (_n - _this._timeEnterInnerDBR)), _._onLog("DBR worker handle results: " + (_e - _n)), _._onLog("Total decode image cost: " + (_e - _this._timeStartDecode));
                      }

                      return i(_t2);
                    }

                    {
                      var _t3 = new Error(e.message);

                      return _t3.stack = e.stack + "\n" + _t3.stack, a(_t3);
                    }
                  }), _this._timeEnterInnerDBR = Date.now(), _._onLog && _._onLog("Send buffer to worker:" + _this._timeEnterInnerDBR), _._dbrWorker.postMessage({
                    type: "decodeBuffer",
                    id: d,
                    instanceID: _this._instanceID,
                    body: {
                      buffer: e,
                      width: t,
                      height: n,
                      stride: r,
                      format: s,
                      config: o
                    }
                  }, [e.buffer]), _._onLog && o && o._timeEndGettingFrame && _._onLog("decode image delay: " + (_this._timeEnterInnerDBR - o._timeEndGettingFrame));
                });

              case 2:
                return _context4.abrupt("return", _context4.sent);

              case 3:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
    }
  }, {
    key: "_decodeBuffer_Blob",
    value: function _decodeBuffer_Blob(e, t, n, r, s, o) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var i;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _._onLog && _._onLog("_decodeBuffer_Blob(buffer,width,height,stride,format)");

                if (!e.arrayBuffer) {
                  _context5.next = 7;
                  break;
                }

                _context5.next = 4;
                return e.arrayBuffer();

              case 4:
                _context5.t0 = _context5.sent;
                _context5.next = 10;
                break;

              case 7:
                _context5.next = 9;
                return new Promise(function (t, i) {
                  var n = new FileReader();
                  n.readAsArrayBuffer(e), n.onload = function () {
                    t(n.result);
                  }, n.onerror = function () {
                    i(n.error);
                  };
                });

              case 9:
                _context5.t0 = _context5.sent;

              case 10:
                i = _context5.t0;
                _context5.next = 13;
                return this._decodeBuffer_Uint8Array(new Uint8Array(i), t, n, r, s, o);

              case 13:
                return _context5.abrupt("return", _context5.sent);

              case 14:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "decodeBuffer",
    value: function decodeBuffer(e, t, n, r, s, o) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var i;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _._onLog && _._onLog("decodeBuffer(buffer,width,height,stride,format)");
                _._onLog && (this._timeStartDecode = Date.now());

                if (!(e instanceof Uint8Array || e instanceof Uint8ClampedArray)) {
                  _context6.next = 8;
                  break;
                }

                _context6.next = 5;
                return this._decodeBuffer_Uint8Array(e, t, n, r, s, o);

              case 5:
                i = _context6.sent;
                _context6.next = 19;
                break;

              case 8:
                if (!(e instanceof ArrayBuffer)) {
                  _context6.next = 14;
                  break;
                }

                _context6.next = 11;
                return this._decodeBuffer_Uint8Array(new Uint8Array(e), t, n, r, s, o);

              case 11:
                i = _context6.sent;
                _context6.next = 19;
                break;

              case 14:
                _context6.t0 = e instanceof Blob;

                if (!_context6.t0) {
                  _context6.next = 19;
                  break;
                }

                _context6.next = 18;
                return this._decodeBuffer_Blob(e, t, n, r, s, o);

              case 18:
                i = _context6.sent;

              case 19:
                return _context6.abrupt("return", i);

              case 20:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));
    }
  }, {
    key: "_decodeFileInMemory_Uint8Array",
    value: function _decodeFileInMemory_Uint8Array(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _this2 = this;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return new Promise(function (t, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (e) {
                    if (e.success) {
                      var _n2;

                      _this2._lastInnerDecodeDuration = e.duration;

                      try {
                        _n2 = _this2._handleRetJsonString(e.decodeReturn);
                      } catch (e) {
                        return i(e);
                      }

                      return t(_n2);
                    }

                    {
                      var _t4 = new Error(e.message);

                      return _t4.stack = e.stack + "\n" + _t4.stack, i(_t4);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "decodeFileInMemory",
                    id: n,
                    instanceID: _this2._instanceID,
                    body: {
                      bytes: e
                    }
                  });
                });

              case 2:
                return _context7.abrupt("return", _context7.sent);

              case 3:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));
    }
  }, {
    key: "getRuntimeSettings",
    value: function getRuntimeSettings() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee8() {
        var _this3 = this;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) {
                      var _t5 = JSON.parse(i.results);

                      return null != _this3.userDefinedRegion && (_t5.region = JSON.parse(JSON.stringify(_this3.userDefinedRegion))), e(_t5);
                    }

                    {
                      var _e2 = new Error(i.message);

                      return _e2.stack = i.stack + "\n" + _e2.stack, t(_e2);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "getRuntimeSettings",
                    id: i,
                    instanceID: _this3._instanceID
                  });
                });

              case 2:
                return _context8.abrupt("return", _context8.sent);

              case 3:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
    }
  }, {
    key: "updateRuntimeSettings",
    value: function updateRuntimeSettings(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var _this4 = this;

        var t, _e3, _e4, _e5, _e6, _e7;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!("string" == typeof e)) {
                  _context9.next = 52;
                  break;
                }

                if (!("speed" == e)) {
                  _context9.next = 18;
                  break;
                }

                _context9.next = 4;
                return this.getRuntimeSettings();

              case 4:
                _e3 = _context9.sent;
                _context9.next = 7;
                return this.resetRuntimeSettings();

              case 7:
                _context9.next = 9;
                return this.getRuntimeSettings();

              case 9:
                t = _context9.sent;
                t.barcodeFormatIds = _e3.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e3.barcodeFormatIds_2;
                t.region = _e3.region;
                t.deblurLevel = 3;
                t.expectedBarcodesCount = 0;
                t.localizationModes = [2, 0, 0, 0, 0, 0, 0, 0];
                _context9.next = 50;
                break;

              case 18:
                if (!("balance" == e)) {
                  _context9.next = 35;
                  break;
                }

                _context9.next = 21;
                return this.getRuntimeSettings();

              case 21:
                _e4 = _context9.sent;
                _context9.next = 24;
                return this.resetRuntimeSettings();

              case 24:
                _context9.next = 26;
                return this.getRuntimeSettings();

              case 26:
                t = _context9.sent;
                t.barcodeFormatIds = _e4.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e4.barcodeFormatIds_2;
                t.region = _e4.region;
                t.deblurLevel = 5;
                t.expectedBarcodesCount = 512;
                t.localizationModes = [2, 16, 0, 0, 0, 0, 0, 0];
                _context9.next = 50;
                break;

              case 35:
                if (!("coverage" == e)) {
                  _context9.next = 49;
                  break;
                }

                _context9.next = 38;
                return this.getRuntimeSettings();

              case 38:
                _e5 = _context9.sent;
                _context9.next = 41;
                return this.resetRuntimeSettings();

              case 41:
                _context9.next = 43;
                return this.getRuntimeSettings();

              case 43:
                t = _context9.sent;
                t.barcodeFormatIds = _e5.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e5.barcodeFormatIds_2;
                t.region = _e5.region;
                _context9.next = 50;
                break;

              case 49:
                t = JSON.parse(e);

              case 50:
                _context9.next = 55;
                break;

              case 52:
                if (!("object" != typeof e)) {
                  _context9.next = 54;
                  break;
                }

                throw TypeError("'UpdateRuntimeSettings(settings)': Type of 'settings' should be 'string' or 'PlainObject'.");

              case 54:
                if (t = JSON.parse(JSON.stringify(e)), t.region instanceof Array) {
                  _e6 = t.region;
                  [_e6.regionLeft, _e6.regionTop, _e6.regionLeft, _e6.regionBottom, _e6.regionMeasuredByPercentage].some(function (e) {
                    return void 0 !== e;
                  }) && (t.region = {
                    regionLeft: _e6.regionLeft || 0,
                    regionTop: _e6.regionTop || 0,
                    regionRight: _e6.regionRight || 0,
                    regionBottom: _e6.regionBottom || 0,
                    regionMeasuredByPercentage: _e6.regionMeasuredByPercentage || 0
                  });
                }

              case 55:
                if (_._bUseFullFeature) {
                  _context9.next = 60;
                  break;
                }

                if (!(0 != (t.barcodeFormatIds & ~(o.BF_ONED | o.BF_QR_CODE | o.BF_PDF417 | o.BF_DATAMATRIX)) || 0 != t.barcodeFormatIds_2)) {
                  _context9.next = 58;
                  break;
                }

                throw Error("Some of the specified barcode formats are not supported in the compact version. Please try the full-featured version.");

              case 58:
                if (!(0 != t.intermediateResultTypes)) {
                  _context9.next = 60;
                  break;
                }

                throw Error("Intermediate results is not supported in the compact version. Please try the full-featured version.");

              case 60:
                if (!this.bFilterRegionInJs) {
                  _context9.next = 67;
                  break;
                }

                _e7 = t.region;

                if (!(_e7 instanceof Array)) {
                  _context9.next = 64;
                  break;
                }

                throw Error("The `region` of type `Array` is only allowed in `BarcodeScanner`.");

              case 64:
                this.userDefinedRegion = JSON.parse(JSON.stringify(_e7)), (_e7.regionLeft || _e7.regionTop || _e7.regionRight || _e7.regionBottom || _e7.regionMeasuredByPercentage) && (_e7.regionLeft || _e7.regionTop || 100 != _e7.regionRight || 100 != _e7.regionBottom || !_e7.regionMeasuredByPercentage) ? this.region = _e7 : this.region = null, t.region = {
                  regionLeft: 0,
                  regionTop: 0,
                  regionRight: 0,
                  regionBottom: 0,
                  regionMeasuredByPercentage: 0
                };
                _context9.next = 68;
                break;

              case 67:
                this.userDefinedRegion = null, this.region = null;

              case 68:
                _context9.next = 70;
                return new Promise(function (e, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (t) {
                    if (t.success) {
                      try {
                        _this4._handleRetJsonString(t.updateReturn);
                      } catch (e) {
                        i(e);
                      }

                      return e();
                    }

                    {
                      var _e8 = new Error(t.message);

                      return _e8.stack = t.stack + "\n" + _e8.stack, i(_e8);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "updateRuntimeSettings",
                    id: n,
                    instanceID: _this4._instanceID,
                    body: {
                      settings: JSON.stringify(t)
                    }
                  });
                });

              case 70:
                return _context9.abrupt("return", _context9.sent);

              case 71:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));
    }
  }, {
    key: "resetRuntimeSettings",
    value: function resetRuntimeSettings() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee10() {
        var _this5 = this;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                this.userDefinedRegion = null;
                this.region = null;
                _context10.next = 4;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) return e();
                    {
                      var _e9 = new Error(i.message);

                      return _e9.stack = i.stack + "\n" + _e9.stack, t(_e9);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "resetRuntimeSettings",
                    id: i,
                    instanceID: _this5._instanceID
                  });
                });

              case 4:
                return _context10.abrupt("return", _context10.sent);

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));
    }
  }, {
    key: "outputSettingsToString",
    value: function outputSettingsToString() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee11() {
        var _this6 = this;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                if (_._bUseFullFeature) {
                  _context11.next = 2;
                  break;
                }

                throw Error("outputSettingsToString() is not supported in the compact version. Please try the full-featured version.");

              case 2:
                _context11.next = 4;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) return e(i.results);
                    {
                      var _e10 = new Error(i.message);

                      return _e10.stack = i.stack + "\n" + _e10.stack, t(_e10);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "outputSettingsToString",
                    id: i,
                    instanceID: _this6._instanceID
                  });
                });

              case 4:
                return _context11.abrupt("return", _context11.sent);

              case 5:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));
    }
  }, {
    key: "initRuntimeSettingsWithString",
    value: function initRuntimeSettingsWithString(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee12() {
        var _this7 = this;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                if (_._bUseFullFeature) {
                  _context12.next = 2;
                  break;
                }

                throw Error("initRuntimeSettingsWithString() is not supported in the compact version. Please try the full-featured version.");

              case 2:
                if (!("string" == typeof e)) {
                  _context12.next = 6;
                  break;
                }

                e = e;
                _context12.next = 9;
                break;

              case 6:
                if (!("object" != typeof e)) {
                  _context12.next = 8;
                  break;
                }

                throw TypeError("'initRuntimeSettingstWithString(settings)': Type of 'settings' should be 'string' or 'PlainObject'.");

              case 8:
                e = JSON.stringify(e);

              case 9:
                _context12.next = 11;
                return new Promise(function (t, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (e) {
                    if (e.success) {
                      try {
                        _this7._handleRetJsonString(e.initReturn);
                      } catch (e) {
                        i(e);
                      }

                      return t();
                    }

                    {
                      var _t6 = new Error(e.message);

                      return _t6.stack = e.stack + "\n" + _t6.stack, i(_t6);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "initRuntimeSettingsWithString",
                    id: n,
                    instanceID: _this7._instanceID,
                    body: {
                      settings: e
                    }
                  });
                });

              case 11:
                return _context12.abrupt("return", _context12.sent);

              case 12:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));
    }
  }, {
    key: "_decode_Blob",
    value: function _decode_Blob(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee13() {
        var i, n, r;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _._onLog && _._onLog("_decode_Blob(blob: Blob)");
                i = null, n = null;

                if (!("undefined" != typeof createImageBitmap)) {
                  _context13.next = 11;
                  break;
                }

                _context13.prev = 3;
                _context13.next = 6;
                return createImageBitmap(e);

              case 6:
                i = _context13.sent;
                _context13.next = 11;
                break;

              case 9:
                _context13.prev = 9;
                _context13.t0 = _context13["catch"](3);

              case 11:
                _context13.t1 = i;

                if (_context13.t1) {
                  _context13.next = 16;
                  break;
                }

                _context13.next = 15;
                return function (e) {
                  return new Promise(function (t, i) {
                    var n = URL.createObjectURL(e),
                        r = new Image();
                    r.dbrObjUrl = n, r.src = n, r.onload = function () {
                      t(r);
                    }, r.onerror = function (e) {
                      i(new Error("Can't convert blob to image : " + (e instanceof Event ? e.type : e)));
                    };
                  });
                }(e);

              case 15:
                n = _context13.sent;

              case 16:
                _context13.next = 18;
                return this._decode_Image(i || n, t);

              case 18:
                r = _context13.sent;
                return _context13.abrupt("return", (i && i.close(), r));

              case 20:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[3, 9]]);
      }));
    }
  }, {
    key: "_decode_ArrayBuffer",
    value: function _decode_ArrayBuffer(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee14() {
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return this._decode_Blob(new Blob([e]), t);

              case 2:
                return _context14.abrupt("return", _context14.sent);

              case 3:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this);
      }));
    }
  }, {
    key: "_decode_Uint8Array",
    value: function _decode_Uint8Array(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee15() {
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return this._decode_Blob(new Blob([e]), t);

              case 2:
                return _context15.abrupt("return", _context15.sent);

              case 3:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this);
      }));
    }
  }, {
    key: "_decode_Image",
    value: function _decode_Image(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee16() {
        var i, n, r, s, o, a, l, _e11, _t7, _r, _s, c, _e12, u, h, g;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _._onLog && _._onLog("_decode_Image(image: HTMLImageElement|ImageBitmap)"), t = t || {};
                o = e instanceof HTMLImageElement ? e.naturalWidth : e.width, a = e instanceof HTMLImageElement ? e.naturalHeight : e.height, l = t.region;

                if (l) {
                  l.regionMeasuredByPercentage ? (_e11 = l.regionLeft * o / 100, _t7 = l.regionTop * a / 100, _r = l.regionRight * o / 100, _s = l.regionBottom * a / 100) : (_e11 = l.regionLeft, _t7 = l.regionTop, _r = l.regionRight, _s = l.regionBottom), i = _e11, n = _t7, o = Math.round(_r - _e11), a = Math.round(_s - _t7);
                } else i = 0, n = 0;

                c = Math.max(o, a);

                if (c > this._canvasMaxWH) {
                  _e12 = this._canvasMaxWH / c;
                  o > a ? (r = this._canvasMaxWH, s = Math.round(a * _e12)) : (r = Math.round(o * _e12), s = this._canvasMaxWH);
                } else r = o, s = a;

                !this.bSaveOriCanvas && d.OffscreenCanvas ? u = new OffscreenCanvas(r, s) : (u = document.createElement("canvas"), u.width = r, u.height = s), u.getContext("2d").drawImage(e, i, n, o, a, 0, 0, r, s), e.dbrObjUrl && URL.revokeObjectURL(e.dbrObjUrl), l ? (h = JSON.parse(JSON.stringify(t)), delete h.region) : h = t;
                _context16.next = 8;
                return this._decode_Canvas(u, h);

              case 8:
                g = _context16.sent;
                return _context16.abrupt("return", (_.fixResultLocationWhenFilterRegionInJs(l, g, i, n, o, a, r, s), g));

              case 10:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this);
      }));
    }
  }, {
    key: "_decode_Canvas",
    value: function _decode_Canvas(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee17() {
        var i;
        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                if (!(_._onLog && _._onLog("_decode_Canvas(canvas:HTMLCanvasElement)"), e.crossOrigin && "anonymous" != e.crossOrigin)) {
                  _context17.next = 2;
                  break;
                }

                throw "cors";

              case 2:
                (this.bSaveOriCanvas || this.singleFrameMode) && (this.oriCanvas = e);
                i = (e.dbrCtx2d || e.getContext("2d")).getImageData(0, 0, e.width, e.height).data;
                _context17.next = 6;
                return this._decodeBuffer_Uint8Array(i, e.width, e.height, 4 * e.width, n.IPF_ABGR_8888, t);

              case 6:
                return _context17.abrupt("return", _context17.sent);

              case 7:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this);
      }));
    }
  }, {
    key: "_decode_Video",
    value: function _decode_Video(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee18() {
        var i, n, r, s, o, a, l, _e13, _t8, _r2, _s2, c, _e14, u, h, g;

        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                if (!(_._onLog && _._onLog("_decode_Video(video)"), !(e instanceof HTMLVideoElement))) {
                  _context18.next = 2;
                  break;
                }

                throw TypeError("'_decode_Video(video [, config] )': Type of 'video' should be 'HTMLVideoElement'.");

              case 2:
                if (!(e.crossOrigin && "anonymous" != e.crossOrigin)) {
                  _context18.next = 4;
                  break;
                }

                throw "cors";

              case 4:
                t = t || {};
                o = e.videoWidth, a = e.videoHeight, l = t.region;

                if (l) {
                  l.regionMeasuredByPercentage ? (_e13 = l.regionLeft * o / 100, _t8 = l.regionTop * a / 100, _r2 = l.regionRight * o / 100, _s2 = l.regionBottom * a / 100) : (_e13 = l.regionLeft, _t8 = l.regionTop, _r2 = l.regionRight, _s2 = l.regionBottom), i = _e13, n = _t8, o = Math.round(_r2 - _e13), a = Math.round(_s2 - _t8);
                } else i = 0, n = 0;

                c = Math.max(o, a);

                if (c > this._canvasMaxWH) {
                  _e14 = this._canvasMaxWH / c;
                  o > a ? (r = this._canvasMaxWH, s = Math.round(a * _e14)) : (r = Math.round(o * _e14), s = this._canvasMaxWH);
                } else r = o, s = a;

                u = null;
                !this.bSaveOriCanvas && d.OffscreenCanvas ? u = new OffscreenCanvas(r, s) : (u = document.createElement("canvas"), u.width = r, u.height = s);
                (u.dbrCtx2d = u.getContext("2d")).drawImage(e, i, n, o, a, 0, 0, r, s), l ? (h = JSON.parse(JSON.stringify(t)), delete h.region) : h = t;
                _context18.next = 14;
                return this._decode_Canvas(u, t);

              case 14:
                g = _context18.sent;
                return _context18.abrupt("return", (l && _.fixResultLocationWhenFilterRegionInJs(l, g, i, n, o, a, r, s), g));

              case 16:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this);
      }));
    }
  }, {
    key: "_decode_Base64",
    value: function _decode_Base64(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee19() {
        var i, _n3, _r3;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                if (!(_._onLog && _._onLog("_decode_Base64(base64Str)"), "string" != typeof e)) {
                  _context19.next = 2;
                  break;
                }

                return _context19.abrupt("return", Promise.reject("'_decode_Base64(base64Str, config)': Type of 'base64Str' should be 'string'."));

              case 2:
                "data:image/" == e.substring(0, 11) && (e = e.substring(e.indexOf(",") + 1));
                i = atob(e), _n3 = i.length, _r3 = new Uint8Array(_n3);

                for (; _n3--;) {
                  _r3[_n3] = i.charCodeAt(_n3);
                }

                _context19.next = 7;
                return this._decode_Blob(new Blob([_r3]), t);

              case 7:
                return _context19.abrupt("return", _context19.sent);

              case 8:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this);
      }));
    }
  }, {
    key: "_decode_Url",
    value: function _decode_Url(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee21() {
        var _this8 = this;

        var _n4;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                if (!(_._onLog && _._onLog("_decode_Url(url)"), "string" != typeof e)) {
                  _context21.next = 2;
                  break;
                }

                throw TypeError("'_decode_Url(url, config)': Type of 'url' should be 'string'.");

              case 2:
                e = e;
                _context21.next = 5;
                return new Promise(function (t, n) {
                  var r = new XMLHttpRequest();
                  r.open("GET", e, !0), r.responseType = "blob", r.send(), r.onloadend = function () {
                    return i(_this8, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee20() {
                      return _regeneratorRuntime.wrap(function _callee20$(_context20) {
                        while (1) {
                          switch (_context20.prev = _context20.next) {
                            case 0:
                              t(r.response);

                            case 1:
                            case "end":
                              return _context20.stop();
                          }
                        }
                      }, _callee20);
                    }));
                  }, r.onerror = function () {
                    n(new Error("Network Error: " + r.statusText));
                  };
                });

              case 5:
                _n4 = _context21.sent;
                _context21.next = 8;
                return this._decode_Blob(_n4, t);

              case 8:
                return _context21.abrupt("return", _context21.sent);

              case 9:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this);
      }));
    }
  }, {
    key: "_decode_FilePath",
    value: function _decode_FilePath(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee22() {
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                throw _._onLog && _._onLog("_decode_FilePath(path)"), Error("'_decode_FilePath(path, config)': The method is only supported in node environment.");

              case 1:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));
    }
  }, {
    key: "_handleRetJsonString",
    value: function _handleRetJsonString(e) {
      var t = r;

      if (e.textResults) {
        for (var _t9 = 0; _t9 < e.textResults.length; _t9++) {
          var _i = e.textResults[_t9];

          try {
            var _e15 = _i.barcodeText,
                _t10 = "";

            for (var _i2 = 0; _i2 < _e15.length; _i2++) {
              _t10 += String.fromCharCode(_e15[_i2]);
            }

            try {
              _i.barcodeText = decodeURIComponent(escape(_t10));
            } catch (e) {
              _i.barcodeText = _t10;
            }
          } catch (e) {
            _i.barcodeText = "";
          }

          if (null != _i.exception) {
            (function () {
              _._setWarnnedEx.has(_i.exception) || (_._setWarnnedEx.add(_i.exception), console.warn(_i.exception));
              var e = {};
              _i.exception.split(";").forEach(function (t) {
                var i = t.indexOf(":");
                e[t.substring(0, i)] = t.substring(i + 1);
              }), _i.exception = e;
            })();
          }
        }

        return e.decodeRecords ? this.decodeRecords = e.decodeRecords : this.decodeRecords = {}, this._lastErrorCode = e.exception, this._lastErrorString = e.description, e.exception && !_._setWarnnedEx.has(e.description) && (_._setWarnnedEx.add(e.description), console.warn(e.description)), e.textResults;
      }

      if (e.exception == t.DBR_SUCCESS) return e.data;
      throw _.BarcodeReaderException(e.exception, e.description);
    }
  }, {
    key: "setModeArgument",
    value: function setModeArgument(e, t, n, r) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee23() {
        var _this9 = this;

        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.next = 2;
                return new Promise(function (i, s) {
                  var o = _._nextTaskID++;
                  _._taskCallbackMap.set(o, function (e) {
                    if (e.success) {
                      try {
                        _this9._handleRetJsonString(e.setReturn);
                      } catch (e) {
                        return s(e);
                      }

                      return i();
                    }

                    {
                      var _t11 = new Error(e.message);

                      return _t11.stack = e.stack + "\n" + _t11.stack, s(_t11);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "setModeArgument",
                    id: o,
                    instanceID: _this9._instanceID,
                    body: {
                      modeName: e,
                      index: t,
                      argumentName: n,
                      argumentValue: r
                    }
                  });
                });

              case 2:
                return _context23.abrupt("return", _context23.sent);

              case 3:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));
    }
  }, {
    key: "getModeArgument",
    value: function getModeArgument(e, t, n) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee24() {
        var _this10 = this;

        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                _context24.next = 2;
                return new Promise(function (i, r) {
                  var s = _._nextTaskID++;
                  _._taskCallbackMap.set(s, function (e) {
                    if (e.success) {
                      var _t12;

                      try {
                        _t12 = _this10._handleRetJsonString(e.getReturn);
                      } catch (e) {
                        return r(e);
                      }

                      return i(_t12);
                    }

                    {
                      var _t13 = new Error(e.message);

                      return _t13.stack = e.stack + "\n" + _t13.stack, r(_t13);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "getModeArgument",
                    id: s,
                    instanceID: _this10._instanceID,
                    body: {
                      modeName: e,
                      index: t,
                      argumentName: n
                    }
                  });
                });

              case 2:
                return _context24.abrupt("return", _context24.sent);

              case 3:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));
    }
  }, {
    key: "getIntermediateResults",
    value: function getIntermediateResults() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee25() {
        var _this11 = this;

        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                _context25.next = 2;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) return e(i.results);
                    {
                      var _e16 = new Error(i.message);

                      return _e16.stack = i.stack + "\n" + _e16.stack, t(_e16);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "getIntermediateResults",
                    id: i,
                    instanceID: _this11._instanceID
                  });
                });

              case 2:
                return _context25.abrupt("return", _context25.sent);

              case 3:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));
    }
  }, {
    key: "getIntermediateCanvas",
    value: function getIntermediateCanvas() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
        var e, t, _iterator, _step, _i3, _iterator2, _step2, _e17, _i4, _r4, _e18, _t14, _e19, _t15, _t16, _e20, _t17, _i5, _s3, _o;

        return _regeneratorRuntime.wrap(function _callee26$(_context26) {
          while (1) {
            switch (_context26.prev = _context26.next) {
              case 0:
                _context26.next = 2;
                return this.getIntermediateResults();

              case 2:
                e = _context26.sent;
                t = [];
                _iterator = _createForOfIteratorHelper(e);
                _context26.prev = 5;

                _iterator.s();

              case 7:
                if ((_step = _iterator.n()).done) {
                  _context26.next = 52;
                  break;
                }

                _i3 = _step.value;

                if (!(_i3.dataType == s.IMRDT_IMAGE)) {
                  _context26.next = 50;
                  break;
                }

                _iterator2 = _createForOfIteratorHelper(_i3.results);
                _context26.prev = 11;

                _iterator2.s();

              case 13:
                if ((_step2 = _iterator2.n()).done) {
                  _context26.next = 42;
                  break;
                }

                _e17 = _step2.value;
                _i4 = _e17.bytes;
                _r4 = void 0;
                _context26.t0 = (_._onLog && _._onLog(" " + _i4.length + " " + _i4.byteLength + " " + _e17.width + " " + _e17.height + " " + _e17.stride + " " + _e17.format), _e17.format);
                _context26.next = _context26.t0 === n.IPF_ABGR_8888 ? 20 : _context26.t0 === n.IPF_RGB_888 ? 22 : _context26.t0 === n.IPF_GrayScaled ? 26 : _context26.t0 === n.IPF_Binary ? 30 : _context26.t0 === n.IPF_BinaryInverted ? 30 : 35;
                break;

              case 20:
                _r4 = new Uint8ClampedArray(_i4);
                return _context26.abrupt("break", 36);

              case 22:
                _e18 = _i4.length / 3;
                _r4 = new Uint8ClampedArray(4 * _e18);

                for (_t14 = 0; _t14 < _e18; ++_t14) {
                  _r4[4 * _t14] = _i4[3 * _t14 + 2], _r4[4 * _t14 + 1] = _i4[3 * _t14 + 1], _r4[4 * _t14 + 2] = _i4[3 * _t14], _r4[4 * _t14 + 3] = 255;
                }

                return _context26.abrupt("break", 36);

              case 26:
                _e19 = _i4.length;
                _r4 = new Uint8ClampedArray(4 * _e19);

                for (_t15 = 0; _t15 < _e19; _t15++) {
                  _r4[4 * _t15] = _r4[4 * _t15 + 1] = _r4[4 * _t15 + 2] = _i4[_t15], _r4[4 * _t15 + 3] = 255;
                }

                return _context26.abrupt("break", 36);

              case 30:
                _e17.width = 8 * _e17.stride, _e17.height = _i4.length / _e17.stride;
                _t16 = _i4.length;
                _r4 = new Uint8ClampedArray(8 * _t16 * 4);

                for (_e20 = 0; _e20 < _t16; _e20++) {
                  _t17 = _i4[_e20];

                  for (_i5 = 0; _i5 < 8; ++_i5) {
                    _r4[4 * (8 * _e20 + _i5)] = _r4[4 * (8 * _e20 + _i5) + 1] = _r4[4 * (8 * _e20 + _i5) + 2] = (128 & _t17) / 128 * 255, _r4[4 * (8 * _e20 + _i5) + 3] = 255, _t17 <<= 1;
                  }
                }

                return _context26.abrupt("break", 36);

              case 35:
                console.warn("unknow intermediate image", _e17);

              case 36:
                if (_r4) {
                  _context26.next = 38;
                  break;
                }

                return _context26.abrupt("continue", 40);

              case 38:
                _s3 = new ImageData(_r4, _e17.width, _e17.height), _o = document.createElement("canvas");
                _o.width = _e17.width, _o.height = _e17.height, _o.getContext("2d").putImageData(_s3, 0, 0), t.push(_o);

              case 40:
                _context26.next = 13;
                break;

              case 42:
                _context26.next = 47;
                break;

              case 44:
                _context26.prev = 44;
                _context26.t1 = _context26["catch"](11);

                _iterator2.e(_context26.t1);

              case 47:
                _context26.prev = 47;

                _iterator2.f();

                return _context26.finish(47);

              case 50:
                _context26.next = 7;
                break;

              case 52:
                _context26.next = 57;
                break;

              case 54:
                _context26.prev = 54;
                _context26.t2 = _context26["catch"](5);

                _iterator.e(_context26.t2);

              case 57:
                _context26.prev = 57;

                _iterator.f();

                return _context26.finish(57);

              case 60:
                return _context26.abrupt("return", t);

              case 61:
              case "end":
                return _context26.stop();
            }
          }
        }, _callee26, this, [[5, 54, 57, 60], [11, 44, 47, 50]]);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.destroyContext();
    }
  }, {
    key: "destroyContext",
    value: function destroyContext() {
      var _this12 = this;

      if (_._onLog && _._onLog("destroyContext()"), !this.bDestroyed) return this.bDestroyed = !0, new Promise(function (e, t) {
        var i = _._nextTaskID++;
        _._taskCallbackMap.set(i, function (i) {
          if (i.success) return e();
          {
            var _e21 = new Error(i.message);

            return _e21.stack = i.stack + "\n" + _e21.stack, t(_e21);
          }
        }), _._dbrWorker.postMessage({
          type: "destroyContext",
          id: i,
          instanceID: _this12._instanceID
        });
      });
    }
  }, {
    key: "ifSaveOriginalImageInACanvas",
    get: function get() {
      return this.bSaveOriCanvas;
    },
    set: function set(e) {
      this.bSaveOriCanvas = e;
    }
  }, {
    key: "region",
    set: function set(e) {
      this._region = e;
    },
    get: function get() {
      return this._region;
    }
  }, {
    key: "lastErrorCode",
    get: function get() {
      return this._lastErrorCode;
    }
  }, {
    key: "lastErrorString",
    get: function get() {
      return this._lastErrorString;
    }
  }], [{
    key: "detectEnvironment",
    value: function detectEnvironment() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee27() {
        var e;
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                e = {
                  wasm: "undefined" != typeof WebAssembly && ("undefined" == typeof navigator || !(/Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent) && /\(.+\s11_2_([2-6]).*\)/.test(navigator.userAgent))),
                  worker: !("undefined" == typeof Worker),
                  getUserMedia: !("undefined" == typeof navigator || !navigator.mediaDevices || !navigator.mediaDevices.getUserMedia),
                  camera: !1,
                  browser: this.browserInfo.browser,
                  version: this.browserInfo.version,
                  OS: this.browserInfo.OS
                };

                if (!e.getUserMedia) {
                  _context27.next = 11;
                  break;
                }

                _context27.prev = 2;
                _context27.next = 5;
                return navigator.mediaDevices.getUserMedia({
                  video: !0
                });

              case 5:
                _context27.sent.getTracks().forEach(function (e) {
                  e.stop();
                });

                e.camera = !0;
                _context27.next = 11;
                break;

              case 9:
                _context27.prev = 9;
                _context27.t0 = _context27["catch"](2);

              case 11:
                return _context27.abrupt("return", e);

              case 12:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27, this, [[2, 9]]);
      }));
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return "loadSuccess" == this._loadWasmStatus;
    }
  }, {
    key: "loadWasm",
    value: function loadWasm() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee30() {
        var _this13 = this;

        var e, t, n, s, o, a, l, _e22, _e23, _i6, _e24;

        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = _._license, n = JSON.parse(JSON.stringify(_._licenseServer)), s = _._sessionPassword, o = null, a = null, l = 0;
                if (t.startsWith("t") || t.startsWith("f")) l = 0;else if (0 === t.length || t.startsWith("P") || t.startsWith("L")) l = 1;else {
                  l = 2;
                  _e22 = t.indexOf(":");

                  if (-1 != _e22 && (t = t.substring(_e22 + 1)), t.startsWith("DLS2")) {
                    _e23 = t.substring(4);
                    _e23 = atob(_e23);
                    _i6 = JSON.parse(_e23);

                    if (_i6.handshakeCode ? t = _i6.handshakeCode : _i6.organizationID && (t = _i6.organizationID), "number" == typeof t && (t = JSON.stringify(t)), t || (t = ""), 0 === n.length) {
                      _e24 = [];
                      _i6.mainServerURL && (_e24[0] = _i6.mainServerURL), _i6.standbyServerURL && (_e24[1] = _i6.standbyServerURL), _.licenseServer = _e24, n = _.licenseServer;
                    }

                    !s && _i6.sessionPassword && (s = _i6.sessionPassword), _i6.chargeWay && (a = _i6.chargeWay), _i6.limitedLicenseModules && (o = _i6.limitedLicenseModules);
                  }
                }

                if (!(l && (d.crypto || (e = "Please upgrade your browser to support online key."), d.crypto.subtle || (e = "Require https to use online key in this browser.")), e)) {
                  _context30.next = 6;
                  break;
                }

                if (!(1 !== l)) {
                  _context30.next = 5;
                  break;
                }

                throw new Error(e);

              case 5:
                l = 0, console.warn(e), _._lastErrorCode = r.DMERR_FAILED_TO_REACH_LTS, _._lastErrorString = e;

              case 6:
                1 === l && (t = "", console.warn("Automatically apply for a public trial license."));
                _context30.next = 9;
                return new Promise(function (e, r) {
                  return i(_this13, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee29() {
                    var _this14 = this;

                    var _e25;

                    return _regeneratorRuntime.wrap(function _callee29$(_context29) {
                      while (1) {
                        switch (_context29.prev = _context29.next) {
                          case 0:
                            _context29.t0 = _._loadWasmStatus;
                            _context29.next = _context29.t0 === "unload" ? 3 : _context29.t0 === "loading" ? 14 : _context29.t0 === "loadSuccess" ? 16 : _context29.t0 === "loadFail" ? 18 : 19;
                            break;

                          case 3:
                            _._loadWasmStatus = "loading";
                            _e25 = _.engineResourcePath + _._workerName;
                            _context29.t1 = _.engineResourcePath.startsWith(location.origin);

                            if (_context29.t1) {
                              _context29.next = 10;
                              break;
                            }

                            _context29.next = 9;
                            return fetch(_e25).then(function (e) {
                              return e.blob();
                            }).then(function (e) {
                              return URL.createObjectURL(e);
                            });

                          case 9:
                            _e25 = _context29.sent;

                          case 10:
                            _._dbrWorker = new Worker(_e25);

                            _._dbrWorker.onerror = function (e) {
                              _._loadWasmStatus = "loadFail";
                              var t = new Error(e.message);
                              _._loadWasmErr = t;

                              var _iterator3 = _createForOfIteratorHelper(_._loadWasmCallbackArr),
                                  _step3;

                              try {
                                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                                  var _e26 = _step3.value;

                                  _e26(t);
                                }
                              } catch (err) {
                                _iterator3.e(err);
                              } finally {
                                _iterator3.f();
                              }

                              _._loadWasmCallbackArr = [];
                            };

                            _._dbrWorker.onmessage = function (e) {
                              return i(_this14, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
                                var t, _e27, _iterator4, _step4, _e28, _i7, _iterator5, _step5, _e29, _e30, _i8;

                                return _regeneratorRuntime.wrap(function _callee28$(_context28) {
                                  while (1) {
                                    switch (_context28.prev = _context28.next) {
                                      case 0:
                                        t = e.data ? e.data : e;
                                        _context28.t0 = t.type;
                                        _context28.next = _context28.t0 === "log" ? 4 : _context28.t0 === "load" ? 6 : _context28.t0 === "task" ? 11 : 20;
                                        break;

                                      case 4:
                                        _._onLog && _._onLog(t.message);
                                        return _context28.abrupt("break", 21);

                                      case 6:
                                        t.message && (t.message = t.message.replace("(https://www.dynamsoft.com/purchase-center/)", "(https://www.dynamsoft.com/store/dynamsoft-barcode-reader/#javascript)"));
                                        _e27 = !1;

                                        if (1 === l && (_e27 = !0), t.success) {
                                          _._loadWasmStatus = "loadSuccess", _._version = t.version + "(JS " + _._jsVersion + "." + _._jsEditVersion + ")", _._onLog && _._onLog("load dbr worker success");
                                          _iterator4 = _createForOfIteratorHelper(_._loadWasmCallbackArr);

                                          try {
                                            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                                              _e28 = _step4.value;

                                              _e28();
                                            }
                                          } catch (err) {
                                            _iterator4.e(err);
                                          } finally {
                                            _iterator4.f();
                                          }

                                          _._loadWasmCallbackArr = [], _._dbrWorker.onerror = null, t.message && console.warn(t.message);
                                        } else {
                                          _i7 = new Error(t.message);
                                          _i7.stack = t.stack + "\n" + _i7.stack, _._loadWasmStatus = "loadFail", _._loadWasmErr = _i7;
                                          _iterator5 = _createForOfIteratorHelper(_._loadWasmCallbackArr);

                                          try {
                                            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                                              _e29 = _step5.value;

                                              _e29(_i7);
                                            }
                                          } catch (err) {
                                            _iterator5.e(err);
                                          } finally {
                                            _iterator5.f();
                                          }

                                          _._loadWasmCallbackArr = [], _e27 || 111 == t.ltsErrorCode && -1 != t.message.toLowerCase().indexOf("trial license") && (_e27 = !0);
                                        }

                                        _e27 && _.showDialog(t.success ? "warn" : "error", t.message);
                                        return _context28.abrupt("break", 21);

                                      case 11:
                                        _e30 = t.id, _i8 = t.body;
                                        _context28.prev = 12;
                                        _._taskCallbackMap.get(_e30)(_i8), _._taskCallbackMap.delete(_e30);
                                        _context28.next = 19;
                                        break;

                                      case 16:
                                        _context28.prev = 16;
                                        _context28.t1 = _context28["catch"](12);
                                        throw _._taskCallbackMap.delete(_e30), _context28.t1;

                                      case 19:
                                        return _context28.abrupt("break", 21);

                                      case 20:
                                        _._onLog && _._onLog(e);

                                      case 21:
                                      case "end":
                                        return _context28.stop();
                                    }
                                  }
                                }, _callee28, null, [[12, 16]]);
                              }));
                            };

                            _._dbrWorker.postMessage({
                              type: "loadWasm",
                              bd: _._bWasmDebug,
                              engineResourcePath: _.engineResourcePath,
                              version: _._jsVersion,
                              brtk: !!l,
                              bptk: 1 === l,
                              lcs: t,
                              dm: location.origin.startsWith("http") ? location.origin : "https://localhost",
                              bUseFullFeature: _._bUseFullFeature,
                              browserInfo: _.browserInfo,
                              deviceFriendlyName: _.deviceFriendlyName,
                              ls: n,
                              sp: s,
                              lm: o,
                              cw: a
                            });

                          case 14:
                            _._loadWasmCallbackArr.push(function (t) {
                              t ? r(t) : e();
                            });

                            return _context29.abrupt("break", 19);

                          case 16:
                            e();
                            return _context29.abrupt("break", 19);

                          case 18:
                            r(_._loadWasmErr);

                          case 19:
                          case "end":
                            return _context29.stop();
                        }
                      }
                    }, _callee29);
                  }));
                });

              case 9:
                return _context30.abrupt("return", _context30.sent);

              case 10:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30);
      }));
    }
  }, {
    key: "showDialog",
    value: function showDialog(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee32() {
        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                if (_._bNeverShowDialog) {
                  _context32.next = 8;
                  break;
                }

                _context32.prev = 1;
                return _context32.delegateYield( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31() {
                  var i, n, r, s, _e31, _t18, o, a, d, l, c, u, h, g, _iterator6, _step6, _e36, _e32, _iterator7, _step7, _t19, _loop, _i9, _h;

                  return _regeneratorRuntime.wrap(function _callee31$(_context31) {
                    while (1) {
                      switch (_context31.prev = _context31.next) {
                        case 0:
                          _context31.next = 2;
                          return fetch(_.engineResourcePath + "dls.license.dialog.html");

                        case 2:
                          i = _context31.sent;

                          if (i.ok) {
                            _context31.next = 5;
                            break;
                          }

                          throw Error("Get license dialog fail. Network Error: " + i.statusText);

                        case 5:
                          _context31.next = 7;
                          return i.text();

                        case 7:
                          n = _context31.sent;

                          if (n.trim().startsWith("<")) {
                            _context31.next = 10;
                            break;
                          }

                          throw Error("Get license dialog fail. Can't get valid HTMLElement.");

                        case 10:
                          r = document.createElement("div");
                          r.innerHTML = n;
                          s = [];

                          for (_e31 = 0; _e31 < r.childElementCount; ++_e31) {
                            _t18 = r.children[_e31];
                            _t18 instanceof HTMLStyleElement && (s.push(_t18), document.head.append(_t18));
                          }

                          o = 1 == r.childElementCount ? r.children[0] : r;
                          o.remove();
                          h = [o], g = o.children;
                          _iterator6 = _createForOfIteratorHelper(g);

                          try {
                            for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                              _e36 = _step6.value;
                              h.push(_e36);
                            }
                          } catch (err) {
                            _iterator6.e(err);
                          } finally {
                            _iterator6.f();
                          }

                          for (_e32 = 0; _e32 < h.length; ++_e32) {
                            _iterator7 = _createForOfIteratorHelper(h[_e32].children);

                            try {
                              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                                _t19 = _step7.value;
                                h.push(_t19);
                              }
                            } catch (err) {
                              _iterator7.e(err);
                            } finally {
                              _iterator7.f();
                            }
                          }

                          _loop = function _loop() {
                            var i = _h[_i9];
                            if (!a && i.classList.contains("dls-license-mask")) a = i, i.addEventListener("click", function (e) {
                              if (i == e.target) {
                                o.remove();

                                var _iterator8 = _createForOfIteratorHelper(s),
                                    _step8;

                                try {
                                  for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                                    var _e33 = _step8.value;

                                    _e33.remove();
                                  }
                                } catch (err) {
                                  _iterator8.e(err);
                                } finally {
                                  _iterator8.f();
                                }
                              }
                            });else if (!d && i.classList.contains("dls-license-icon-close")) d = i, i.addEventListener("click", function () {
                              o.remove();

                              var _iterator9 = _createForOfIteratorHelper(s),
                                  _step9;

                              try {
                                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                                  var _e34 = _step9.value;

                                  _e34.remove();
                                }
                              } catch (err) {
                                _iterator9.e(err);
                              } finally {
                                _iterator9.f();
                              }
                            });else if (!l && i.classList.contains("dls-license-icon-error")) l = i, "error" != e && i.remove();else if (!c && i.classList.contains("dls-license-icon-warn")) c = i, "warn" != e && i.remove();else if (!u && i.classList.contains("dls-license-msg-content")) {
                              u = i;
                              var _e35 = t;

                              for (; _e35;) {
                                var _t20 = _e35.indexOf("["),
                                    _n5 = _e35.indexOf("]", _t20),
                                    _r5 = _e35.indexOf("(", _n5),
                                    _s4 = _e35.indexOf(")", _r5);

                                if (-1 == _t20 || -1 == _n5 || -1 == _r5 || -1 == _s4) {
                                  i.appendChild(new Text(_e35));
                                  break;
                                }

                                _t20 > 0 && i.appendChild(new Text(_e35.substring(0, _t20)));

                                var _o2 = document.createElement("a"),
                                    _a = _e35.substring(_t20 + 1, _n5);

                                _o2.innerText = _a;

                                var _d = _e35.substring(_r5 + 1, _s4);

                                _o2.setAttribute("href", _d), _o2.setAttribute("target", "_blank"), i.appendChild(_o2), _e35 = _e35.substring(_s4 + 1);
                              }
                            }
                          };

                          for (_i9 = 0, _h = h; _i9 < _h.length; _i9++) {
                            _loop();
                          }

                          document.body.appendChild(o);

                        case 23:
                        case "end":
                          return _context31.stop();
                      }
                    }
                  }, _callee31);
                })(), "t0", 3);

              case 3:
                _context32.next = 8;
                break;

              case 5:
                _context32.prev = 5;
                _context32.t1 = _context32["catch"](1);
                _._onLog && _._onLog(_context32.t1.message || _context32.t1);

              case 8:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, null, [[1, 5]]);
      }));
    }
  }, {
    key: "createInstanceInWorker",
    value: function createInstanceInWorker() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : !1;
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee33() {
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                _context33.next = 2;
                return _.loadWasm();

              case 2:
                _context33.next = 4;
                return new Promise(function (t, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (e) {
                    if (e.success) return t(e.instanceID);
                    {
                      var _t21 = new Error(e.message);

                      return _t21.stack = e.stack + "\n" + _t21.stack, i(_t21);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "createInstance",
                    id: n,
                    bScanner: e
                  });
                });

              case 4:
                return _context33.abrupt("return", _context33.sent);

              case 5:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));
    }
  }, {
    key: "createInstance",
    value: function createInstance() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee34() {
        var e;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                e = new _();
                _context34.next = 3;
                return _.createInstanceInWorker();

              case 3:
                e._instanceID = _context34.sent;
                return _context34.abrupt("return", e);

              case 5:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34);
      }));
    }
  }, {
    key: "fixResultLocationWhenFilterRegionInJs",
    value: function fixResultLocationWhenFilterRegionInJs(e, t, i, n, r, s, o, a) {
      if (e && t.length > 0) {
        var _iterator10 = _createForOfIteratorHelper(t),
            _step10;

        try {
          for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
            var _e37 = _step10.value;
            var _t22 = _e37.localizationResult;
            2 == _t22.resultCoordinateType && (_t22.x1 *= .01 * o, _t22.x2 *= .01 * o, _t22.x3 *= .01 * o, _t22.x4 *= .01 * o, _t22.y1 *= .01 * a, _t22.y2 *= .01 * a, _t22.y3 *= .01 * a, _t22.y4 *= .01 * a);

            var _d2 = o / r,
                _2 = a / s;

            _t22.x1 = _t22.x1 / _d2 + i, _t22.x2 = _t22.x2 / _d2 + i, _t22.x3 = _t22.x3 / _d2 + i, _t22.x4 = _t22.x4 / _d2 + i, _t22.y1 = _t22.y1 / _2 + n, _t22.y2 = _t22.y2 / _2 + n, _t22.y3 = _t22.y3 / _2 + n, _t22.y4 = _t22.y4 / _2 + n, 2 == _t22.resultCoordinateType && (_t22.x1 *= 100 / r, _t22.x2 *= 100 / r, _t22.x3 *= 100 / r, _t22.x4 *= 100 / r, _t22.y1 *= 100 / s, _t22.y2 *= 100 / s, _t22.y3 *= 100 / s, _t22.y4 *= 100 / s);
          }
        } catch (err) {
          _iterator10.e(err);
        } finally {
          _iterator10.f();
        }
      }
    }
  }, {
    key: "BarcodeReaderException",
    value: function BarcodeReaderException(e, t) {
      var i,
          n = r.DBR_UNKNOWN;
      return "number" == typeof e ? (n = e, i = new Error(t)) : i = new Error(e), i.code = n, i;
    }
  }, {
    key: "version",
    get: function get() {
      return this._version;
    }
  }, {
    key: "license",
    get: function get() {
      return this._license;
    },
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`license` is not allowed to change after `createInstance` or `loadWasm` is called.");
      _._license = e;
    }
  }, {
    key: "productKeys",
    get: function get() {
      return this._license;
    },
    set: function set(e) {
      _.license = e;
    }
  }, {
    key: "handshakeCode",
    get: function get() {
      return this._license;
    },
    set: function set(e) {
      _.license = e;
    }
  }, {
    key: "organizationID",
    get: function get() {
      return this._license;
    },
    set: function set(e) {
      _.license = e;
    }
  }, {
    key: "sessionPassword",
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`sessionPassword` is not allowed to change after `createInstance` or `loadWasm` is called.");
      _._sessionPassword = e;
    },
    get: function get() {
      return this._sessionPassword;
    }
  }, {
    key: "engineResourcePath",
    get: function get() {
      return this._engineResourcePath;
    },
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`engineResourcePath` is not allowed to change after `createInstance` or `loadWasm` is called.");
      if (null == e && (e = "./"), a) _._engineResourcePath = e;else {
        var t = document.createElement("a");
        t.href = e, _._engineResourcePath = t.href;
      }
      this._engineResourcePath.endsWith("/") || (_._engineResourcePath += "/");
    }
  }, {
    key: "licenseServer",
    get: function get() {
      return this._licenseServer;
    },
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`licenseServer` is not allowed to change after `createInstance` or `loadWasm` is called.");
      if (null == e) _._licenseServer = [];else {
        e instanceof Array || (e = [e]);

        for (var t = 0; t < e.length; ++t) {
          if (!a) {
            var _i10 = document.createElement("a");

            _i10.href = e[t], e[t] = _i10.href;
          }

          e[t].endsWith("/") || (e[t] += "/");
        }

        _._licenseServer = e;
      }
    }
  }, {
    key: "deviceFriendlyName",
    get: function get() {
      return this._deviceFriendlyName;
    },
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`deviceFriendlyName` is not allowed to change after `createInstance` or `loadWasm` is called.");
      _._deviceFriendlyName = e || "";
    }
  }, {
    key: "_bUseFullFeature",
    get: function get() {
      return this.__bUseFullFeature;
    },
    set: function set(e) {
      if ("unload" != this._loadWasmStatus) throw new Error("`_bUseFullFeature` is not allowed to change after `createInstance` or `loadWasm` is called.");
      _.__bUseFullFeature = e;
    }
  }, {
    key: "lastErrorCode",
    get: function get() {
      return this._lastErrorCode;
    }
  }, {
    key: "lastErrorString",
    get: function get() {
      return this._lastErrorString;
    }
  }]);

  return _;
}();

_._jsVersion = "8.8.7", _._jsEditVersion = "20220125", _._version = "loading...(JS " + _._jsVersion + "." + _._jsEditVersion + ")", _._license = !a && document.currentScript && (document.currentScript.getAttribute("data-license") || document.currentScript.getAttribute("data-productKeys") || document.currentScript.getAttribute("data-licenseKey") || document.currentScript.getAttribute("data-handshakeCode") || document.currentScript.getAttribute("data-organizationID")) || "", _._sessionPassword = !a && document.currentScript && document.currentScript.getAttribute("data-sessionPassword") || "", _.browserInfo = function () {
  if (!a) {
    var e = {
      init: function init() {
        this.browser = this.searchString(this.dataBrowser) || "unknownBrowser", this.version = this.searchVersion(navigator.userAgent) || this.searchVersion(navigator.appVersion) || "unknownVersion", this.OS = this.searchString(this.dataOS) || "unknownOS", "Linux" == this.OS && -1 != navigator.userAgent.indexOf("Windows NT") && (this.OS = "HarmonyOS");
      },
      searchString: function searchString(e) {
        for (var t = 0; t < e.length; t++) {
          var i = e[t].string,
              n = e[t].prop;

          if (this.versionSearchString = e[t].versionSearch || e[t].identity, i) {
            if (-1 != i.indexOf(e[t].subString)) return e[t].identity;
          } else if (n) return e[t].identity;
        }
      },
      searchVersion: function searchVersion(e) {
        var t = e.indexOf(this.versionSearchString);
        if (-1 != t) return parseFloat(e.substring(t + this.versionSearchString.length + 1));
      },
      dataBrowser: [{
        string: navigator.userAgent,
        subString: "Edge",
        identity: "Edge"
      }, {
        string: navigator.userAgent,
        subString: "OPR",
        identity: "OPR"
      }, {
        string: navigator.userAgent,
        subString: "Chrome",
        identity: "Chrome"
      }, {
        string: navigator.vendor,
        subString: "Apple",
        identity: "Safari",
        versionSearch: "Version"
      }, {
        string: navigator.userAgent,
        subString: "Firefox",
        identity: "Firefox"
      }, {
        string: navigator.userAgent,
        subString: "MSIE",
        identity: "Explorer",
        versionSearch: "MSIE"
      }],
      dataOS: [{
        string: navigator.userAgent,
        subString: "HarmonyOS",
        identity: "HarmonyOS"
      }, {
        string: navigator.userAgent,
        subString: "Android",
        identity: "Android"
      }, {
        string: navigator.userAgent,
        subString: "iPhone",
        identity: "iPhone"
      }, {
        string: navigator.platform,
        subString: "Win",
        identity: "Windows"
      }, {
        string: navigator.platform,
        subString: "Mac",
        identity: "Mac"
      }, {
        string: navigator.platform,
        subString: "Linux",
        identity: "Linux"
      }]
    };
    return e.init(), {
      browser: e.browser,
      version: e.version,
      OS: e.OS
    };
  }

  if (a) return {
    browser: "ssr",
    version: 0,
    OS: "ssr"
  };
}(), _._workerName = "dbr-" + _._jsVersion + ".worker.js", _._engineResourcePath = function () {
  if (!a && document.currentScript) {
    var _e38 = document.currentScript.src,
        t = _e38.indexOf("?");

    if (-1 != t) _e38 = _e38.substring(0, t);else {
      var _t23 = _e38.indexOf("#");

      -1 != _t23 && (_e38 = _e38.substring(0, _t23));
    }
    return _e38.substring(0, _e38.lastIndexOf("/") + 1);
  }

  return "./";
}(), _._licenseServer = [], _._deviceFriendlyName = "", _._isShowRelDecodeTimeInResults = !1, _._bWasmDebug = !1, _._bNeverShowDialog = !1, _.__bUseFullFeature = !0, _._nextTaskID = 0, _._taskCallbackMap = new Map(), _._loadWasmStatus = "unload", _._loadWasmCallbackArr = [], _._lastErrorCode = 0, _._lastErrorString = "", _._setWarnnedEx = new Set(), _._loadWasmErr = null, "object" == typeof global && global.process && global.process.release && global.process.release.name;

var l = /*#__PURE__*/function (_ref) {
  _inherits(l, _ref);

  function l() {
    var _this15;

    _classCallCheck(this, l);

    _this15 = _possibleConstructorReturn(this, _getPrototypeOf(l).call(this)), _this15._clickIptSingleFrameMode = function () {}, _this15.intervalTime = 0, _this15.bSaveOriCanvas = !1, _this15._intervalGetVideoFrame = 0, _this15.array_getFrameTimeCost = [], _this15.array_decodeFrameTimeCost = [], _this15._indexCurrentDecodingFrame = 0, _this15._bPauseScan = !1, _this15._intervalDetectVideoPause = 1e3, _this15._cvsDrawArea = null, _this15._divScanArea = null, _this15._divScanLight = null, _this15._selCam = null, _this15._selRsl = null, _this15._btnClose = null, _this15._soundOnSuccessfullRead = new Audio("data:audio/mpeg;base64,SUQzBAAAAAAAI1RTU0UAAAAPAAADTGF2ZjU4LjI5LjEwMAAAAAAAAAAAAAAA/+M4wAAAAAAAAAAAAEluZm8AAAAPAAAABQAAAkAAgICAgICAgICAgICAgICAgICAgKCgoKCgoKCgoKCgoKCgoKCgoKCgwMDAwMDAwMDAwMDAwMDAwMDAwMDg4ODg4ODg4ODg4ODg4ODg4ODg4P//////////////////////////AAAAAExhdmM1OC41NAAAAAAAAAAAAAAAACQEUQAAAAAAAAJAk0uXRQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA/+MYxAANQAbGeUEQAAHZYZ3fASqD4P5TKBgocg+Bw/8+CAYBA4XB9/4EBAEP4nB9+UOf/6gfUCAIKyjgQ/Kf//wfswAAAwQA/+MYxAYOqrbdkZGQAMA7DJLCsQxNOij///////////+tv///3RWiZGBEhsf/FO/+LoCSFs1dFVS/g8f/4Mhv0nhqAieHleLy/+MYxAYOOrbMAY2gABf/////////////////usPJ66R0wI4boY9/8jQYg//g2SPx1M0N3Z0kVJLIs///Uw4aMyvHJJYmPBYG/+MYxAgPMALBucAQAoGgaBoFQVBUFQWDv6gZBUFQVBUGgaBr5YSgqCoKhIGg7+IQVBUFQVBoGga//SsFSoKnf/iVTEFNRTMu/+MYxAYAAANIAAAAADEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV"), _this15.bPlaySoundOnSuccessfulRead = !1, _this15.bVibrateOnSuccessfulRead = !1, _this15.vibrateDuration = 300, _this15.regionMaskFillStyle = "rgba(0,0,0,0.5)", _this15.regionMaskStrokeStyle = "rgb(254,142,20)", _this15.regionMaskLineWidth = 2, _this15.barcodeFillStyle = "rgba(254,180,32,0.3)", _this15.barcodeStrokeStyle = "rgba(254,180,32,0.9)", _this15.barcodeLineWidth = 1, _this15.beingLazyDrawRegionsults = !1, _this15.dce = null, _this15._onCameraSelChange = function () {
      _this15._divScanLight && (_this15._divScanLight.style.display = "none"), _this15._drawRegionsults(), _this15.array_decodeFrameTimeCost.length = 0, _this15.array_getFrameTimeCost.length = 0, _this15._intervalGetVideoFrame = 0;
    }, _this15._onResolutionSelChange = function () {
      _this15._divScanLight && (_this15._divScanLight.style.display = "none"), _this15._drawRegionsults(), _this15.array_decodeFrameTimeCost.length = 0, _this15.array_getFrameTimeCost.length = 0, _this15._intervalGetVideoFrame = 0;
    }, _this15._onCloseBtnClick = function () {
      _this15.hide();
    };
    return _this15;
  }

  _createClass(l, [{
    key: "getUIElement",
    value: function getUIElement() {
      return this.dce.getUIElement();
    }
  }, {
    key: "setUIElement",
    value: function setUIElement(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee35() {
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                _context35.next = 2;
                return this.dce.setUIElement(e);

              case 2:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, this);
      }));
    }
  }, {
    key: "_assertOpen",
    value: function _assertOpen() {
      if (!this.dce.isOpen()) throw Error("The scanner is not open.");
    }
  }, {
    key: "createDCEInstance",
    value: function createDCEInstance() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
        var _this16 = this;

        return _regeneratorRuntime.wrap(function _callee37$(_context37) {
          while (1) {
            switch (_context37.prev = _context37.next) {
              case 0:
                _context37.t0 = this.dce;

                if (_context37.t0) {
                  _context37.next = 14;
                  break;
                }

                _._onLog && _._onLog("createDCEInstance()");
                t.defaultUIElementURL = null;
                _context37.next = 6;
                return t.createInstance();

              case 6:
                this.dce = _context37.sent;
                this.dce.bChangeRegionIndexManually = !0;
                this.dce.regionIndex = 0;
                this.dce.bufferRefreshInterval = 200;
                this.dce.alwaysRefreshBuffer = !1;
                this.dce.ifSaveOriginalImageInACanvas = !1;

                this.dce.onSingleFrameAcquired = function (e) {
                  return i(_this16, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee36() {
                    var t, _iterator11, _step11, _e40, _iterator12, _step12, _e39;

                    return _regeneratorRuntime.wrap(function _callee36$(_context36) {
                      while (1) {
                        switch (_context36.prev = _context36.next) {
                          case 0:
                            _context36.next = 2;
                            return this.decode(e);

                          case 2:
                            t = _context36.sent;
                            _context36.next = 5;
                            return this.clearMapDecodeRecord();

                          case 5:
                            _iterator11 = _createForOfIteratorHelper(t);

                            try {
                              for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
                                _e40 = _step11.value;
                                delete _e40.bUnduplicated;
                              }
                            } catch (err) {
                              _iterator11.e(err);
                            } finally {
                              _iterator11.f();
                            }

                            if (this._drawRegionsults(t), this.onFrameRead && this.isOpen() && !this._bPauseScan && this.onFrameRead(t), this.onUniqueRead && this.isOpen() && !this._bPauseScan) {
                              _iterator12 = _createForOfIteratorHelper(t);

                              try {
                                for (_iterator12.s(); !(_step12 = _iterator12.n()).done;) {
                                  _e39 = _step12.value;
                                  this.onUniqueRead(_e39.barcodeText, _e39);
                                }
                              } catch (err) {
                                _iterator12.e(err);
                              } finally {
                                _iterator12.f();
                              }
                            }

                          case 8:
                          case "end":
                            return _context36.stop();
                        }
                      }
                    }, _callee36, this);
                  }));
                };

                this._clickIptSingleFrameMode = this.dce._clickIptSingleFrameMode;

              case 14:
              case "end":
                return _context37.stop();
            }
          }
        }, _callee37, this);
      }));
    }
  }, {
    key: "decode",
    value: function decode(e) {
      return _get(_getPrototypeOf(l.prototype), "decode", this).call(this, e);
    }
  }, {
    key: "decodeBase64String",
    value: function decodeBase64String(e) {
      return _get(_getPrototypeOf(l.prototype), "decodeBase64String", this).call(this, e);
    }
  }, {
    key: "decodeUrl",
    value: function decodeUrl(e) {
      return _get(_getPrototypeOf(l.prototype), "decodeUrl", this).call(this, e);
    }
  }, {
    key: "decodeBuffer",
    value: function decodeBuffer(e, t, i, n, r, s) {
      return _get(_getPrototypeOf(l.prototype), "decodeBuffer", this).call(this, e, t, i, n, r, s);
    }
  }, {
    key: "decodeCurrentFrame",
    value: function decodeCurrentFrame(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee38() {
        var t, i, _e41, _t24, _r6, _e42, _t25, _r7, _s5, _o3, _a2, _d3, _l;

        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                this._assertOpen();

                t = null;
                e && e.region && (t = e.region);
                i = this.dce.getFrame(t);

                if (!(i && null === i.canvas)) {
                  _context38.next = 9;
                  break;
                }

                _e41 = i.data, _t24 = i.width, _r6 = i.height;
                _context38.next = 8;
                return this._decodeBuffer_Uint8Array(_e41, _t24, _r6, _t24, n.IPF_GrayScaled);

              case 8:
                return _context38.abrupt("return", _context38.sent);

              case 9:
                if (!(i && i.canvas)) {
                  _context38.next = 16;
                  break;
                }

                _e42 = i.data, _t25 = i.canvas, _r7 = i.region, _s5 = i.sx, _o3 = i.sy, _a2 = i.sWidth, _d3 = i.sHeight;
                (this.bSaveOriCanvas || this.singleFrameMode) && (this.oriCanvas = _t25);
                _context38.next = 14;
                return this._decodeBuffer_Uint8Array(_e42, _t25.width, _t25.height, 4 * _t25.width, n.IPF_ABGR_8888);

              case 14:
                _l = _context38.sent;
                return _context38.abrupt("return", (_.fixResultLocationWhenFilterRegionInJs(_r7, _l, _s5, _o3, _a2, _d3, _t25.width, _t25.height), _l));

              case 16:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, this);
      }));
    }
  }, {
    key: "clearMapDecodeRecord",
    value: function clearMapDecodeRecord() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee39() {
        var _this17 = this;

        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                _context39.next = 2;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) return e();
                    {
                      var _e43 = new Error(i.message);

                      return _e43.stack = i.stack + "\n" + _e43.stack, t(_e43);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "clearMapDecodeRecord",
                    id: i,
                    instanceID: _this17._instanceID
                  });
                });

              case 2:
                return _context39.abrupt("return", _context39.sent);

              case 3:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39);
      }));
    }
  }, {
    key: "updateRuntimeSettings",
    value: function updateRuntimeSettings(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee40() {
        var _this18 = this;

        var t, _e44, _e45, _e46, _e47, _i11, _e48, _t26, _i12;

        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                if (!("string" == typeof e)) {
                  _context40.next = 72;
                  break;
                }

                if (!("speed" == e)) {
                  _context40.next = 15;
                  break;
                }

                _context40.next = 4;
                return this.getRuntimeSettings();

              case 4:
                _e44 = _context40.sent;
                _context40.next = 7;
                return this.resetRuntimeSettings();

              case 7:
                _context40.next = 9;
                return this.getRuntimeSettings();

              case 9:
                t = _context40.sent;
                t.barcodeFormatIds = _e44.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e44.barcodeFormatIds_2;
                l.isRegionSinglePreset(_e44.region) || (t.region = _e44.region);
                _context40.next = 70;
                break;

              case 15:
                if (!("balance" == e)) {
                  _context40.next = 33;
                  break;
                }

                _context40.next = 18;
                return this.getRuntimeSettings();

              case 18:
                _e45 = _context40.sent;
                _context40.next = 21;
                return this.resetRuntimeSettings();

              case 21:
                _context40.next = 23;
                return this.getRuntimeSettings();

              case 23:
                t = _context40.sent;
                t.barcodeFormatIds = _e45.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e45.barcodeFormatIds_2;
                l.isRegionSinglePreset(_e45.region) || (t.region = _e45.region);
                t.deblurLevel = 3;
                t.expectedBarcodesCount = 512;
                t.localizationModes = [2, 16, 0, 0, 0, 0, 0, 0];
                t.timeout = 1e5;
                _context40.next = 70;
                break;

              case 33:
                if (!("coverage" == e)) {
                  _context40.next = 52;
                  break;
                }

                _context40.next = 36;
                return this.getRuntimeSettings();

              case 36:
                _e46 = _context40.sent;
                _context40.next = 39;
                return this.resetRuntimeSettings();

              case 39:
                _context40.next = 41;
                return this.getRuntimeSettings();

              case 41:
                t = _context40.sent;
                t.barcodeFormatIds = _e46.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e46.barcodeFormatIds_2;
                l.isRegionSinglePreset(_e46.region) || (t.region = _e46.region);
                t.deblurLevel = 5;
                t.expectedBarcodesCount = 512;
                t.scaleDownThreshold = 1e5;
                t.localizationModes = [2, 16, 4, 8, 0, 0, 0, 0];
                t.timeout = 1e5;
                _context40.next = 70;
                break;

              case 52:
                if (!("single" == e)) {
                  _context40.next = 69;
                  break;
                }

                _context40.next = 55;
                return this.getRuntimeSettings();

              case 55:
                _e47 = _context40.sent;
                _context40.next = 58;
                return this.resetRuntimeSettings();

              case 58:
                _context40.next = 60;
                return this.getRuntimeSettings();

              case 60:
                t = _context40.sent;
                t.barcodeFormatIds = _e47.barcodeFormatIds;
                t.barcodeFormatIds_2 = _e47.barcodeFormatIds_2;
                l.isRegionNormalPreset(_e47.region) ? t.region = JSON.parse(JSON.stringify(l.singlePresetRegion)) : t.region = _e47.region;
                t.expectedBarcodesCount = 1;
                t.localizationModes = [16, 2, 0, 0, 0, 0, 0, 0];
                t.barcodeZoneMinDistanceToImageBorders = 0;
                _context40.next = 70;
                break;

              case 69:
                t = JSON.parse(e);

              case 70:
                _context40.next = 75;
                break;

              case 72:
                if (!("object" != typeof e)) {
                  _context40.next = 74;
                  break;
                }

                throw TypeError("'UpdateRuntimeSettings(settings)': Type of 'settings' should be 'string' or 'PlainObject'.");

              case 74:
                if (t = JSON.parse(JSON.stringify(e)), t.region instanceof Array) {
                  _i11 = e.region;
                  [_i11.regionLeft, _i11.regionTop, _i11.regionLeft, _i11.regionBottom, _i11.regionMeasuredByPercentage].some(function (e) {
                    return void 0 !== e;
                  }) && (t.region = {
                    regionLeft: _i11.regionLeft || 0,
                    regionTop: _i11.regionTop || 0,
                    regionRight: _i11.regionRight || 0,
                    regionBottom: _i11.regionBottom || 0,
                    regionMeasuredByPercentage: _i11.regionMeasuredByPercentage || 0
                  });
                }

              case 75:
                if (_._bUseFullFeature) {
                  _context40.next = 80;
                  break;
                }

                if (!(0 != (t.barcodeFormatIds & ~(o.BF_ONED | o.BF_QR_CODE | o.BF_PDF417 | o.BF_DATAMATRIX)) || 0 != t.barcodeFormatIds_2)) {
                  _context40.next = 78;
                  break;
                }

                throw Error("Some of the specified barcode formats are not supported in the compact version. Please try the full-featured version.");

              case 78:
                if (!(0 != t.intermediateResultTypes)) {
                  _context40.next = 80;
                  break;
                }

                throw Error("Intermediate results is not supported in the compact version. Please try the full-featured version.");

              case 80:
                _e48 = t.region;
                if (this.bFilterRegionInJs ? this.userDefinedRegion = JSON.parse(JSON.stringify(_e48)) : this.userDefinedRegion = null, _e48 instanceof Array) {
                  if (_e48.length) {
                    for (_t26 = 0; _t26 < _e48.length; ++_t26) {
                      _i12 = _e48[_t26];
                      _i12 && ((_i12.regionLeft || _i12.regionTop || _i12.regionRight || _i12.regionBottom || _i12.regionMeasuredByPercentage) && (_i12.regionLeft || _i12.regionTop || 100 != _i12.regionRight || 100 != _i12.regionBottom || !_i12.regionMeasuredByPercentage) || (_e48[_t26] = null));
                    }

                    this.region = _e48;
                  } else this.region = null;
                } else (_e48.regionLeft || _e48.regionTop || _e48.regionRight || _e48.regionBottom || _e48.regionMeasuredByPercentage) && (_e48.regionLeft || _e48.regionTop || 100 != _e48.regionRight || 100 != _e48.regionBottom || !_e48.regionMeasuredByPercentage) ? this.region = _e48 : this.region = null;
                this.bFilterRegionInJs && (t.region = {
                  regionLeft: 0,
                  regionTop: 0,
                  regionRight: 0,
                  regionBottom: 0,
                  regionMeasuredByPercentage: 0
                });
                _context40.next = 85;
                return new Promise(function (e, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (t) {
                    if (t.success) {
                      try {
                        _this18._handleRetJsonString(t.updateReturn);
                      } catch (e) {
                        i(e);
                      }

                      return e();
                    }

                    {
                      var _e49 = new Error(t.message);

                      return _e49.stack = t.stack + "\n" + _e49.stack, i(_e49);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "updateRuntimeSettings",
                    id: n,
                    instanceID: _this18._instanceID,
                    body: {
                      settings: JSON.stringify(t)
                    }
                  });
                });

              case 85:
                _context40.t0 = "single" == e;

                if (!_context40.t0) {
                  _context40.next = 95;
                  break;
                }

                _context40.next = 89;
                return this.setModeArgument("BinarizationModes", 0, "EnableFillBinaryVacancy", "0");

              case 89:
                _context40.next = 91;
                return this.setModeArgument("LocalizationModes", 0, "ScanDirection", "2");

              case 91:
                _context40.next = 93;
                return this.setModeArgument("BinarizationModes", 0, "BlockSizeX", "71");

              case 93:
                _context40.next = 95;
                return this.setModeArgument("BinarizationModes", 0, "BlockSizeY", "71");

              case 95:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, this);
      }));
    }
  }, {
    key: "_bindUI",
    value: function _bindUI() {
      var e = this.getUIElement();
      if (!e) throw new Error("Need to define `UIElement` before opening.");
      var t = [e];

      for (var _e50 = 0; _e50 < t.length; ++_e50) {
        var _iterator13 = _createForOfIteratorHelper(t[_e50].children),
            _step13;

        try {
          for (_iterator13.s(); !(_step13 = _iterator13.n()).done;) {
            var _i13 = _step13.value;
            t.push(_i13);
          }
        } catch (err) {
          _iterator13.e(err);
        } finally {
          _iterator13.f();
        }
      }

      for (var _i14 = 0, _t27 = t; _i14 < _t27.length; _i14++) {
        var _e51 = _t27[_i14];
        this.dce._video || !_e51.classList.contains("dce-video") && !_e51.classList.contains("dbrScanner-video") ? this.dce._bgLoading || !_e51.classList.contains("dce-bg-loading") && !_e51.classList.contains("dbrScanner-bg-loading") ? this.dce._bgCamera || !_e51.classList.contains("dce-bg-camera") && !_e51.classList.contains("dbrScanner-bg-camera") ? !this._cvsDrawArea && _e51.classList.contains("dbrScanner-cvs-drawarea") ? this._cvsDrawArea = _e51 : !this._divScanArea && _e51.classList.contains("dbrScanner-cvs-scanarea") ? this._divScanArea = _e51 : !this._divScanLight && _e51.classList.contains("dbrScanner-scanlight") ? this._divScanLight = _e51 : this.dce._selCam || !_e51.classList.contains("dce-sel-camera") && !_e51.classList.contains("dbrScanner-sel-camera") ? !this.dce._selRsl && _e51.classList.contains("dbrScanner-sel-resolution") ? (this.dce._selRsl = _e51, this.dce._selRsl.options.length || (this.dce._selRsl.innerHTML = [this.dce._optGotRsl ? "" : '<option class="dbrScanner-opt-gotResolution" value="got"></option>', '<option data-width="1920" data-height="1080">ask 1920 x 1080</option>', '<option data-width="1280" data-height="720">ask 1280 x 720</option>', '<option data-width="640" data-height="480">ask 640 x 480</option>'].join(""), this.dce._optGotRsl = this.dce._optGotRsl || this.dce._selRsl.options[0])) : this.dce._optGotRsl || !_e51.classList.contains("dce-opt-gotResolution") && !_e51.classList.contains("dbrScanner-opt-gotResolution") ? this.dce._btnClose || !_e51.classList.contains("dce-btn-close") && !_e51.classList.contains("dbrScanner-btn-close") ? this.dce._video || !_e51.classList.contains("dce-existingVideo") && !_e51.classList.contains("dbrScanner-existingVideo") || (this.dce._video = _e51, this.dce._video.setAttribute("playsinline", "true"), this.dce.singleFrameMode = !1) : this.dce._btnClose = _e51 : this.dce._optGotRsl = _e51 : this.dce._selCam = _e51 : this.dce._bgCamera = _e51 : this.dce._bgLoading = _e51 : (this.dce._video = _e51, this.dce._video.setAttribute("playsinline", "true"));
      }

      if (this.dce._bindUI(), this._selCam = this.dce._selCam, this._selRsl = this.dce._selRsl, this._btnClose = this.dce._btnClose, this.singleFrameMode && (this._cvsDrawArea && (this._cvsDrawArea.addEventListener("click", this._clickIptSingleFrameMode), this._cvsDrawArea.style.cursor = "pointer", this._cvsDrawArea.setAttribute("title", "Take a photo")), this._divScanArea && (this._divScanArea.addEventListener("click", this._clickIptSingleFrameMode), this._divScanArea.style.cursor = "pointer", this._divScanArea.setAttribute("title", "Take a photo"))), this._selCam && this._selCam.addEventListener("change", this._onCameraSelChange), this._selRsl && this._selRsl.addEventListener("change", this._onResolutionSelChange), this._btnClose && this._btnClose.addEventListener("click", this._onCloseBtnClick), !this.dce.video) throw this._unbindUI(), Error("Can not find HTMLVideoElement with class `dbrScanner-video`.");
    }
  }, {
    key: "_unbindUI",
    value: function _unbindUI() {
      this._clearRegionsults(), this.singleFrameMode && (this._cvsDrawArea && (this._cvsDrawArea.removeEventListener("click", this._clickIptSingleFrameMode), this._cvsDrawArea.style.cursor = "", this._cvsDrawArea.removeAttribute("title")), this._divScanArea && (this._divScanArea.removeEventListener("click", this._clickIptSingleFrameMode), this._divScanArea.style.cursor = "", this._divScanArea.removeAttribute("title"))), this._selCam && this._selCam.removeEventListener("change", this._onCameraSelChange), this._selRsl && this._selRsl.removeEventListener("change", this._onResolutionSelChange), this._btnClose && this._btnClose.removeEventListener("click", this._onCloseBtnClick), this.dce._unbindUI(), this._cvsDrawArea = null, this._divScanArea = null, this._divScanLight = null, this._selCam = null, this._selRsl = null, this._btnClose = null;
    }
  }, {
    key: "getAllCameras",
    value: function getAllCameras() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee41() {
        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                return _context41.abrupt("return", this.dce.getAllCameras());

              case 1:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41, this);
      }));
    }
  }, {
    key: "getCurrentCamera",
    value: function getCurrentCamera() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee42() {
        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                return _context42.abrupt("return", this.dce.getSelectedCamera());

              case 1:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42, this);
      }));
    }
  }, {
    key: "setCurrentCamera",
    value: function setCurrentCamera(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee43() {
        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                return _context43.abrupt("return", this.dce.selectCamera(e));

              case 1:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43, this);
      }));
    }
  }, {
    key: "getResolution",
    value: function getResolution() {
      return this.dce.getResolution();
    }
  }, {
    key: "setResolution",
    value: function setResolution(e, t) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee44() {
        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                return _context44.abrupt("return", this.dce.setResolution(e, t));

              case 1:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44, this);
      }));
    }
  }, {
    key: "getScanSettings",
    value: function getScanSettings() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee45() {
        var _this19 = this;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                _context45.next = 2;
                return new Promise(function (e, t) {
                  var i = _._nextTaskID++;
                  _._taskCallbackMap.set(i, function (i) {
                    if (i.success) {
                      var _t28 = i.results;
                      return _t28.intervalTime = _this19.intervalTime, e(_t28);
                    }

                    {
                      var _e52 = new Error(i.message);

                      return _e52.stack += "\n" + i.stack, t(_e52);
                    }
                  }), _._dbrWorker.postMessage({
                    type: "getScanSettings",
                    id: i,
                    instanceID: _this19._instanceID
                  });
                });

              case 2:
                return _context45.abrupt("return", _context45.sent);

              case 3:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));
    }
  }, {
    key: "updateScanSettings",
    value: function updateScanSettings(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee46() {
        var _this20 = this;

        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                this.intervalTime = e.intervalTime;
                _context46.next = 3;
                return new Promise(function (t, i) {
                  var n = _._nextTaskID++;
                  _._taskCallbackMap.set(n, function (e) {
                    if (e.success) return t();
                    {
                      var _t29 = new Error(e.message);

                      return _t29.stack += "\n" + e.stack, i(_t29);
                    }
                  }), l._dbrWorker.postMessage({
                    type: "updateScanSettings",
                    id: n,
                    instanceID: _this20._instanceID,
                    body: {
                      settings: e
                    }
                  });
                });

              case 3:
                return _context46.abrupt("return", _context46.sent);

              case 4:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46, this);
      }));
    }
  }, {
    key: "getVideoSettings",
    value: function getVideoSettings() {
      return this.dce.getVideoSettings();
    }
  }, {
    key: "updateVideoSettings",
    value: function updateVideoSettings(e) {
      return this.dce.updateVideoSettings(e);
    }
  }, {
    key: "isOpen",
    value: function isOpen() {
      return this.dce && this.dce.isOpen();
    }
  }, {
    key: "_show",
    value: function _show() {
      var e = this.getUIElement();
      e.parentNode || (e.style.position = "fixed", e.style.left = "0", e.style.top = "0", document.body.append(e)), "none" == e.style.display && (e.style.display = "");
    }
  }, {
    key: "stop",
    value: function stop() {
      this.dce.stop(), this._divScanLight && (this._divScanLight.style.display = "none"), this._drawRegionsults(), this.array_decodeFrameTimeCost.length = 0, this.array_getFrameTimeCost.length = 0, this._intervalGetVideoFrame = 0;
    }
  }, {
    key: "pause",
    value: function pause() {
      this.dce.pause(), this._divScanLight && (this._divScanLight.style.display = "none");
    }
  }, {
    key: "play",
    value: function play(e, t, n) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee47() {
        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                return _context47.abrupt("return", this.dce.play(e, t, n));

              case 1:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47, this);
      }));
    }
  }, {
    key: "pauseScan",
    value: function pauseScan() {
      this._assertOpen(), this._bPauseScan = !0, this._divScanLight && (this._divScanLight.style.display = "none");
    }
  }, {
    key: "resumeScan",
    value: function resumeScan() {
      this._assertOpen(), this._bPauseScan = !1;
    }
  }, {
    key: "getCapabilities",
    value: function getCapabilities() {
      return this.dce.getCapabilities();
    }
  }, {
    key: "getCameraSettings",
    value: function getCameraSettings() {
      return this.dce.getCameraSettings();
    }
  }, {
    key: "getConstraints",
    value: function getConstraints() {
      return this.dce.getConstraints();
    }
  }, {
    key: "applyConstraints",
    value: function applyConstraints(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee48() {
        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                return _context48.abrupt("return", this.dce.applyConstraints(e));

              case 1:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48, this);
      }));
    }
  }, {
    key: "turnOnTorch",
    value: function turnOnTorch() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee49() {
        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                return _context49.abrupt("return", this.dce.turnOnTorch());

              case 1:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49, this);
      }));
    }
  }, {
    key: "turnOffTorch",
    value: function turnOffTorch() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee50() {
        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                return _context50.abrupt("return", this.dce.turnOffTorch());

              case 1:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50, this);
      }));
    }
  }, {
    key: "setColorTemperature",
    value: function setColorTemperature(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee51() {
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                return _context51.abrupt("return", this.dce.setColorTemperature(e));

              case 1:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, this);
      }));
    }
  }, {
    key: "setExposureCompensation",
    value: function setExposureCompensation(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                return _context52.abrupt("return", this.dce.setExposureCompensation(e));

              case 1:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));
    }
  }, {
    key: "setZoom",
    value: function setZoom(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee53() {
        return _regeneratorRuntime.wrap(function _callee53$(_context53) {
          while (1) {
            switch (_context53.prev = _context53.next) {
              case 0:
                return _context53.abrupt("return", this.dce.setZoom(e));

              case 1:
              case "end":
                return _context53.stop();
            }
          }
        }, _callee53, this);
      }));
    }
  }, {
    key: "setFrameRate",
    value: function setFrameRate(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee54() {
        return _regeneratorRuntime.wrap(function _callee54$(_context54) {
          while (1) {
            switch (_context54.prev = _context54.next) {
              case 0:
                return _context54.abrupt("return", this.dce.setFrameRate(e));

              case 1:
              case "end":
                return _context54.stop();
            }
          }
        }, _callee54, this);
      }));
    }
  }, {
    key: "getFrameRate",
    value: function getFrameRate() {
      return this.dce.getFrameRate();
    }
  }, {
    key: "_cloneDecodeResults",
    value: function _cloneDecodeResults(e) {
      if (e instanceof Array) {
        var _t30 = [];

        var _iterator14 = _createForOfIteratorHelper(e),
            _step14;

        try {
          for (_iterator14.s(); !(_step14 = _iterator14.n()).done;) {
            var _i15 = _step14.value;

            _t30.push(this._cloneDecodeResults(_i15));
          }
        } catch (err) {
          _iterator14.e(err);
        } finally {
          _iterator14.f();
        }

        return _t30;
      }

      {
        var _t31 = e;
        return JSON.parse(JSON.stringify(_t31, function (e, t) {
          return "oriVideoCanvas" == e || "searchRegionCanvas" == e ? void 0 : t;
        }));
      }
    }
  }, {
    key: "_loopReadVideo",
    value: function _loopReadVideo() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee56() {
        var _this21 = this;

        var e;
        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                if (!this.bDestroyed) {
                  _context56.next = 2;
                  break;
                }

                return _context56.abrupt("return", void this.dce.stopFetchingLoop());

              case 2:
                if (this.isOpen()) {
                  _context56.next = 7;
                  break;
                }

                this.dce.stopFetchingLoop();
                _context56.next = 6;
                return this.clearMapDecodeRecord();

              case 6:
                return _context56.abrupt("return", void _context56.sent);

              case 7:
                if (!(!this.dce.video || this.dce.video.paused || this._bPauseScan)) {
                  _context56.next = 14;
                  break;
                }

                _._onLog && _._onLog("Video or scan is paused. Ask in 1s.");
                this.dce.stopFetchingLoop();
                _context56.next = 12;
                return this.clearMapDecodeRecord();

              case 12:
                this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId);
                return _context56.abrupt("return", void (this._loopReadVideoTimeoutId = setTimeout(function () {
                  _this21._loopReadVideo();
                }, this._intervalDetectVideoPause)));

              case 14:
                this._divScanLight && "none" == this._divScanLight.style.display && (this._divScanLight.style.display = ""), _._onLog && _._onLog("======= once read ======="), _._onLog && (this._timeStartDecode = Date.now());
                e = this._getVideoFrame();

                if (e) {
                  _context56.next = 18;
                  break;
                }

                return _context56.abrupt("return", (this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId), void (this._loopReadVideoTimeoutId = setTimeout(function () {
                  _this21._loopReadVideo();
                }, 0))));

              case 18:
                (function () {
                  return i(_this21, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee55() {
                    var _t32, _i16, _r8, _s6, _o4, _t33, _i17, _r9, _s7, _o5, _a3, _d4, _l2, _c, _u, _e53;

                    return _regeneratorRuntime.wrap(function _callee55$(_context55) {
                      while (1) {
                        switch (_context55.prev = _context55.next) {
                          case 0:
                            if (!(e && null === e.canvas)) {
                              _context55.next = 5;
                              break;
                            }

                            _t32 = e.data, _i16 = e.width, _r8 = e.height, _s6 = e.timeStamp, _o4 = {
                              timeStamp: _s6
                            };
                            _context55.next = 4;
                            return this._decodeBuffer_Uint8Array(_t32, _i16, _r8, _i16, n.IPF_GrayScaled, _o4);

                          case 4:
                            return _context55.abrupt("return", _context55.sent);

                          case 5:
                            if (!(e && e.canvas)) {
                              _context55.next = 12;
                              break;
                            }

                            _t33 = e.data, _i17 = e.canvas, _r9 = e.region, _s7 = e.sx, _o5 = e.sy, _a3 = e.width, _d4 = e.height, _l2 = e.timeStamp, _c = {
                              timeStamp: _l2
                            };
                            (this.bSaveOriCanvas || this.singleFrameMode) && (this.oriCanvas = _i17);
                            _context55.next = 10;
                            return this._decodeBuffer_Uint8Array(_t33, _i17.width, _i17.height, 4 * _i17.width, n.IPF_ABGR_8888, _c);

                          case 10:
                            _u = _context55.sent;
                            return _context55.abrupt("return", (_.fixResultLocationWhenFilterRegionInJs(_r9, _u, _s7, _o5, _i17.width, _i17.height, _a3, _d4), _u));

                          case 12:
                            _e53 = new Error("imgData is empty.");
                            return _context55.abrupt("return", new Promise(function (t) {
                              return t(_e53);
                            }));

                          case 14:
                          case "end":
                            return _context55.stop();
                        }
                      }
                    }, _callee55, this);
                  }));
                })().then(function (e) {
                  _._onLog && _._onLog(e);
                  var t = _this21.array_decodeFrameTimeCost,
                      i = _this21.array_getFrameTimeCost,
                      n = _this21._indexCurrentDecodingFrame;

                  if (function () {
                    if (_this21.region instanceof Array) {
                      for (t[n] && t[n] instanceof Array || (t[n] = []); t[n].length >= 5;) {
                        t[n].shift();
                      }

                      t[n].push(_this21._lastInnerDecodeDuration);
                    } else {
                      for (; t.length >= 5;) {
                        t.shift();
                      }

                      t.push(_this21._lastInnerDecodeDuration);
                    }
                  }(), _this21._intervalGetVideoFrame = function () {
                    var e = 0;

                    if (_this21.region instanceof Array) {
                      var _r10 = 0,
                          _s8 = 0;
                      _r10 = n + 1 >= _this21.region.length ? 0 : n + 1, _s8 = _r10 + 1 >= _this21.region.length ? 0 : _r10 + 1, e = t[_r10] && t[_r10].length && i[_s8] && i[_s8].length ? Math.min.apply(Math, _toConsumableArray(t[_r10])) - Math.max.apply(Math, _toConsumableArray(i[_s8])) : 0;
                    } else if (i && i.length) {
                      var _n6 = Math.min.apply(Math, _toConsumableArray(t)),
                          _r11 = Math.max.apply(Math, _toConsumableArray(i));

                      _n6 && _r11 && (e = _n6 - _r11);
                    } else e = 0;

                    return e > 0 ? e : 0;
                  }() + _this21.intervalTime, _this21.isOpen() && _this21.dce.video && !_this21.dce.video.paused && !_this21._bPauseScan) {
                    if (_this21.bPlaySoundOnSuccessfulRead && e.length) {
                      var _t34 = !1;

                      if (!0 === _this21.bPlaySoundOnSuccessfulRead || "frame" === _this21.bPlaySoundOnSuccessfulRead) _t34 = !0;else if ("unduplicated" === _this21.bPlaySoundOnSuccessfulRead) {
                        var _iterator15 = _createForOfIteratorHelper(e),
                            _step15;

                        try {
                          for (_iterator15.s(); !(_step15 = _iterator15.n()).done;) {
                            var _i18 = _step15.value;

                            if (_i18.bUnduplicated) {
                              _t34 = !0;
                              break;
                            }
                          }
                        } catch (err) {
                          _iterator15.e(err);
                        } finally {
                          _iterator15.f();
                        }
                      }
                      _t34 && (_this21.soundOnSuccessfullRead.currentTime = 0, _this21.soundOnSuccessfullRead.play().catch(function (e) {
                        console.warn("Autoplay not allowed. User interaction required: " + (e.message || e));
                      }));
                    }

                    if (navigator.vibrate && _this21.bVibrateOnSuccessfulRead && e.length) {
                      var _t35 = !1;

                      if (!0 === _this21.bVibrateOnSuccessfulRead || "frame" === _this21.bVibrateOnSuccessfulRead) _t35 = !0;else if ("unduplicated" === _this21.bVibrateOnSuccessfulRead) {
                        var _iterator16 = _createForOfIteratorHelper(e),
                            _step16;

                        try {
                          for (_iterator16.s(); !(_step16 = _iterator16.n()).done;) {
                            var _i19 = _step16.value;

                            if (_i19.bUnduplicated) {
                              _t35 = !0;
                              break;
                            }
                          }
                        } catch (err) {
                          _iterator16.e(err);
                        } finally {
                          _iterator16.f();
                        }
                      }
                      if (_t35) try {
                        navigator.vibrate(_this21.vibrateDuration);
                      } catch (e) {
                        console.warn("Vibration not allowed. User interaction required: " + (e.message || e));
                      }
                    }

                    if (_this21.onFrameRead) {
                      var _t36 = _this21._cloneDecodeResults(e);

                      var _iterator17 = _createForOfIteratorHelper(_t36),
                          _step17;

                      try {
                        for (_iterator17.s(); !(_step17 = _iterator17.n()).done;) {
                          var _e54 = _step17.value;
                          delete _e54.bUnduplicated;
                        }
                      } catch (err) {
                        _iterator17.e(err);
                      } finally {
                        _iterator17.f();
                      }

                      _this21.onFrameRead(_t36);
                    }

                    if (_this21.onUniqueRead) {
                      var _iterator18 = _createForOfIteratorHelper(e),
                          _step18;

                      try {
                        for (_iterator18.s(); !(_step18 = _iterator18.n()).done;) {
                          var _t37 = _step18.value;
                          _t37.bUnduplicated && _this21.onUniqueRead(_t37.barcodeText, _this21._cloneDecodeResults(_t37));
                        }
                      } catch (err) {
                        _iterator18.e(err);
                      } finally {
                        _iterator18.f();
                      }
                    }

                    _this21._drawRegionsults(e);
                  }

                  _this21._loopReadVideoTimeoutId && clearTimeout(_this21._loopReadVideoTimeoutId), _this21.intervalTime ? _this21._loopReadVideoTimeoutId = setTimeout(function () {
                    _this21._loopReadVideo();
                  }, _this21.intervalTime) : _this21._loopReadVideo();
                }).catch(function (e) {
                  _this21.dce.stopFetchingLoop(), _._onLog && _._onLog(e.message || e), _this21._loopReadVideoTimeoutId && clearTimeout(_this21._loopReadVideoTimeoutId), _this21._loopReadVideoTimeoutId = setTimeout(function () {
                    _this21._loopReadVideo();
                  }, Math.max(_this21.intervalTime, 1e3)), "platform error" == e.message || console.warn(e.message);
                });

              case 19:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));
    }
  }, {
    key: "_getVideoFrame",
    value: function _getVideoFrame() {
      var _this22 = this;

      var e = this.dce.isFetchingLoopStarted();
      if (this.dce.loopInterval = this._intervalGetVideoFrame, e || this.dce.startFetchingLoop(), !this.dce.getQueueLength()) return this.dce.loopInterval = 0, null;
      var t = this.dce.getFrameFromBuffer();
      this._indexCurrentDecodingFrame = this.dce.regionIndex, this.region instanceof Array && this.dce.regionIndex++;
      return function (e) {
        var t = e.timeSpent,
            i = _this22.array_getFrameTimeCost;

        if (_this22.region instanceof Array) {
          var _e55 = _this22._indexCurrentDecodingFrame;

          for (i[_e55] && i[_e55] instanceof Array || (i[_e55] = []); i[_e55].length >= 5;) {
            i[_e55].shift();
          }

          i[_e55].push(t);
        } else {
          for (; i.length >= 5;) {
            i.shift();
          }

          i.push(t);
        }
      }(t), t;
    }
  }, {
    key: "_drawRegionsults",
    value: function _drawRegionsults(e) {
      var t, i, n;

      if (this.beingLazyDrawRegionsults = !1, this.singleFrameMode) {
        if (!this.oriCanvas) return;
        t = "contain", i = this.oriCanvas.width, n = this.oriCanvas.height;
      } else {
        if (!this.dce.video) return;
        t = this.dce.video.style.objectFit || "contain", i = this.dce.video.videoWidth, n = this.dce.video.videoHeight;
      }

      var r = this.region;

      if (r && (!r.regionLeft && !r.regionRight && !r.regionTop && !r.regionBottom && !r.regionMeasuredByPercentage || r instanceof Array ? r = null : r.regionMeasuredByPercentage ? r = r.regionLeft || r.regionRight || 100 !== r.regionTop || 100 !== r.regionBottom ? {
        regionLeft: Math.round(r.regionLeft / 100 * i),
        regionTop: Math.round(r.regionTop / 100 * n),
        regionRight: Math.round(r.regionRight / 100 * i),
        regionBottom: Math.round(r.regionBottom / 100 * n)
      } : null : (r = JSON.parse(JSON.stringify(r)), delete r.regionMeasuredByPercentage)), this._cvsDrawArea) {
        this._cvsDrawArea.style.objectFit = t;
        var _s9 = this._cvsDrawArea;
        _s9.width = i, _s9.height = n;

        var _o6 = _s9.getContext("2d");

        if (r) {
          _o6.fillStyle = this.regionMaskFillStyle, _o6.fillRect(0, 0, _s9.width, _s9.height), _o6.globalCompositeOperation = "destination-out", _o6.fillStyle = "#000";

          var _e56 = Math.round(this.regionMaskLineWidth / 2);

          _o6.fillRect(r.regionLeft - _e56, r.regionTop - _e56, r.regionRight - r.regionLeft + 2 * _e56, r.regionBottom - r.regionTop + 2 * _e56), _o6.globalCompositeOperation = "source-over", _o6.strokeStyle = this.regionMaskStrokeStyle, _o6.lineWidth = this.regionMaskLineWidth, _o6.rect(r.regionLeft, r.regionTop, r.regionRight - r.regionLeft, r.regionBottom - r.regionTop), _o6.stroke();
        }

        if (e) {
          _o6.globalCompositeOperation = "destination-over", _o6.fillStyle = this.barcodeFillStyle, _o6.strokeStyle = this.barcodeStrokeStyle, _o6.lineWidth = this.barcodeLineWidth, e = e || [];

          var _iterator19 = _createForOfIteratorHelper(e),
              _step19;

          try {
            for (_iterator19.s(); !(_step19 = _iterator19.n()).done;) {
              var _t38 = _step19.value;
              var _e57 = _t38.localizationResult;
              _o6.beginPath(), _o6.moveTo(_e57.x1, _e57.y1), _o6.lineTo(_e57.x2, _e57.y2), _o6.lineTo(_e57.x3, _e57.y3), _o6.lineTo(_e57.x4, _e57.y4), _o6.fill(), _o6.beginPath(), _o6.moveTo(_e57.x1, _e57.y1), _o6.lineTo(_e57.x2, _e57.y2), _o6.lineTo(_e57.x3, _e57.y3), _o6.lineTo(_e57.x4, _e57.y4), _o6.closePath(), _o6.stroke();
            }
          } catch (err) {
            _iterator19.e(err);
          } finally {
            _iterator19.f();
          }
        }

        this.singleFrameMode && (_o6.globalCompositeOperation = "destination-over", _o6.drawImage(this.oriCanvas, 0, 0));
      }

      if (this._divScanArea && this.dce.video) {
        var _e58 = this.dce.video.offsetWidth,
            _t39 = this.dce.video.offsetHeight,
            _s10 = 1;
        _e58 / _t39 < i / n ? (_s10 = _e58 / i, this._divScanArea.style.left = "0", this._divScanArea.style.top = Math.round((_t39 - n * _s10) / 2) + "px") : (_s10 = _t39 / n, this._divScanArea.style.left = Math.round((_e58 - i * _s10) / 2) + "px", this._divScanArea.style.top = "0");

        var _o7 = r ? Math.round(r.regionLeft * _s10) : 0,
            _a4 = r ? Math.round(r.regionTop * _s10) : 0,
            _d5 = r ? Math.round(r.regionRight * _s10 - _o7) : Math.round(i * _s10),
            _3 = r ? Math.round(r.regionBottom * _s10 - _a4) : Math.round(n * _s10);

        this._divScanArea.style.marginLeft = _o7 + "px", this._divScanArea.style.marginTop = _a4 + "px", this._divScanArea.style.width = _d5 + "px", this._divScanArea.style.height = _3 + "px";
      }
    }
  }, {
    key: "_clearRegionsults",
    value: function _clearRegionsults() {
      this._cvsDrawArea && (this._cvsDrawArea.width = this._cvsDrawArea.height = 0);
    }
  }, {
    key: "open",
    value: function open() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee57() {
        var e;
        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                this._bindUI();

                _context57.next = 3;
                return this.play();

              case 3:
                e = _context57.sent;
                return _context57.abrupt("return", (this.singleFrameMode || (this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId), this._drawRegionsults(), this._loopReadVideo()), e));

              case 5:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));
    }
  }, {
    key: "openVideo",
    value: function openVideo() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee58() {
        var e;
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                this._bindUI();

                _context58.next = 3;
                return this.play();

              case 3:
                e = _context58.sent;
                return _context58.abrupt("return", (this._bPauseScan = !0, this.singleFrameMode || (this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId), this._drawRegionsults(), this._loopReadVideo()), e));

              case 5:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, this);
      }));
    }
  }, {
    key: "close",
    value: function close() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee59() {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                this.stop(), this._unbindUI(), this._bPauseScan = !1;

              case 1:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, this);
      }));
    }
  }, {
    key: "show",
    value: function show() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee60() {
        var e;
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                this._bindUI(), this._show();
                _context60.next = 3;
                return this.play();

              case 3:
                e = _context60.sent;
                return _context60.abrupt("return", (this.singleFrameMode || (this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId), this._drawRegionsults(), this._loopReadVideo()), e));

              case 5:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, this);
      }));
    }
  }, {
    key: "showVideo",
    value: function showVideo() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee61() {
        var e;
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                this._bindUI(), this._show();
                _context61.next = 3;
                return this.play();

              case 3:
                e = _context61.sent;
                return _context61.abrupt("return", (this._bPauseScan = !0, this.singleFrameMode || (this._loopReadVideoTimeoutId && clearTimeout(this._loopReadVideoTimeoutId), this._drawRegionsults(), this._loopReadVideo()), e));

              case 5:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, this);
      }));
    }
  }, {
    key: "hide",
    value: function hide() {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee62() {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                this.stop(), this._unbindUI(), this._bPauseScan = !1, this.getUIElement().style.display = "none";

              case 1:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, this);
      }));
    }
  }, {
    key: "destroy",
    value: function destroy() {
      return this.destroyContext();
    }
  }, {
    key: "destroyContext",
    value: function destroyContext() {
      var _this23 = this;

      var e = Object.create(null, {
        destroyContext: {
          get: function get() {
            return _get(_getPrototypeOf(l.prototype), "destroyContext", _this23);
          }
        }
      });
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee63() {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.next = 2;
                return this.close();

              case 2:
                _context63.t0 = this.bDestroyed;

                if (_context63.t0) {
                  _context63.next = 6;
                  break;
                }

                _context63.next = 6;
                return e.destroyContext.call(this);

              case 6:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, this);
      }));
    }
  }, {
    key: "singleFrameMode",
    get: function get() {
      return this.dce.singleFrameMode;
    },
    set: function set(e) {
      var _this24 = this;

      this.dce.singleFrameMode = e, e && function () {
        i(_this24, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee64() {
          var e;
          return _regeneratorRuntime.wrap(function _callee64$(_context64) {
            while (1) {
              switch (_context64.prev = _context64.next) {
                case 0:
                  _context64.next = 2;
                  return this.getScanSettings();

                case 2:
                  e = _context64.sent;
                  e.oneDTrustFrameCount = 1;
                  _context64.next = 6;
                  return this.updateScanSettings(e);

                case 6:
                case "end":
                  return _context64.stop();
              }
            }
          }, _callee64, this);
        }));
      }();
    }
  }, {
    key: "ifSaveOriginalImageInACanvas",
    get: function get() {
      return this.bSaveOriCanvas;
    },
    set: function set(e) {
      this.bSaveOriCanvas = e, this.dce && (this.dce.ifSaveOriginalImageInACanvas = e);
    }
  }, {
    key: "soundOnSuccessfullRead",
    get: function get() {
      return this._soundOnSuccessfullRead;
    },
    set: function set(e) {
      e instanceof HTMLAudioElement ? this._soundOnSuccessfullRead = e : this._soundOnSuccessfullRead = new Audio(e);
    }
  }, {
    key: "whenToPlaySoundforSuccessfulRead",
    get: function get() {
      return !0 === this.bPlaySoundOnSuccessfulRead ? "frame" : this.bPlaySoundOnSuccessfulRead ? this.bPlaySoundOnSuccessfulRead : "never";
    },
    set: function set(e) {
      this.bPlaySoundOnSuccessfulRead = "never" !== e && e;
    }
  }, {
    key: "whenToVibrateforSuccessfulRead",
    get: function get() {
      return !0 === this.bVibrateOnSuccessfulRead ? "frame" : this.bVibrateOnSuccessfulRead ? this.bVibrateOnSuccessfulRead : "never";
    },
    set: function set(e) {
      this.bVibrateOnSuccessfulRead = "never" !== e && e;
    }
  }, {
    key: "region",
    set: function set(e) {
      var _this25 = this;

      this._region = e, this.dce && (this.dce.region = e), this.singleFrameMode || (this.beingLazyDrawRegionsults = !0, setTimeout(function () {
        _this25.beingLazyDrawRegionsults && _this25._drawRegionsults();
      }, 500)), this.array_decodeFrameTimeCost.length = 0, this.array_getFrameTimeCost.length = 0, this._intervalGetVideoFrame = 0;
    },
    get: function get() {
      return this._region;
    }
  }, {
    key: "onPlayed",
    set: function set(e) {
      this.dce.onPlayed = e;
    },
    get: function get() {
      return this.dce.onPlayed;
    }
  }, {
    key: "onUnduplicatedRead",
    get: function get() {
      return this.onUniqueRead;
    },
    set: function set(e) {
      this.onUniqueRead = e;
    }
  }], [{
    key: "createInstance",
    value: function createInstance(e) {
      return i(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee65() {
        var t, _i20;

        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                t = new l();
                _context65.next = 3;
                return t.createDCEInstance();

              case 3:
                _context65.next = 5;
                return l.createInstanceInWorker(!0);

              case 5:
                t._instanceID = _context65.sent;
                "string" == typeof e && (e = JSON.parse(e));

                for (_i20 in e) {
                  t[_i20] = e[_i20];
                }

                _context65.next = 10;
                return t.setUIElement(l.defaultUIElementURL);

              case 10:
                t.singleFrameMode && console.warn("The `navigator.mediaDevices.getUserMedia` is unavailable. automatically change to `singleFrameMode`.");
                _context65.t0 = t.singleFrameMode;

                if (_context65.t0) {
                  _context65.next = 15;
                  break;
                }

                _context65.next = 15;
                return t.updateRuntimeSettings("single");

              case 15:
                return _context65.abrupt("return", t);

              case 16:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65);
      }));
    }
  }, {
    key: "isRegionSinglePreset",
    value: function isRegionSinglePreset(e) {
      return JSON.stringify(e) == JSON.stringify(l.singlePresetRegion);
    }
  }, {
    key: "isRegionNormalPreset",
    value: function isRegionNormalPreset(e) {
      return 0 == e.regionLeft && 0 == e.regionTop && 0 == e.regionRight && 0 == e.regionBottom && 0 == e.regionMeasuredByPercentage;
    }
  }, {
    key: "defaultUIElementURL",
    get: function get() {
      var e;
      return null === (e = l._defaultUIElementURL) || void 0 === e ? void 0 : e.replace("@engineResourcePath/", _.engineResourcePath);
    },
    set: function set(e) {
      l._defaultUIElementURL = e;
    }
  }]);

  return l;
}(_);

var c, u, h, g, R, E, I, A, S, D, f, m, T, M, C, L, O, N, y, B, p, v, b, F, P, w, V;
l._defaultUIElementURL = "@engineResourcePath/dbr.scanner.html", l.singlePresetRegion = [null, {
  regionLeft: 0,
  regionTop: 30,
  regionRight: 100,
  regionBottom: 70,
  regionMeasuredByPercentage: 1
}, {
  regionLeft: 25,
  regionTop: 25,
  regionRight: 75,
  regionBottom: 75,
  regionMeasuredByPercentage: 1
}, {
  regionLeft: 25,
  regionTop: 25,
  regionRight: 75,
  regionBottom: 75,
  regionMeasuredByPercentage: 1
}], function (e) {
  e[e.BICM_DARK_ON_LIGHT = 1] = "BICM_DARK_ON_LIGHT", e[e.BICM_LIGHT_ON_DARK = 2] = "BICM_LIGHT_ON_DARK", e[e.BICM_DARK_ON_DARK = 4] = "BICM_DARK_ON_DARK", e[e.BICM_LIGHT_ON_LIGHT = 8] = "BICM_LIGHT_ON_LIGHT", e[e.BICM_DARK_LIGHT_MIXED = 16] = "BICM_DARK_LIGHT_MIXED", e[e.BICM_DARK_ON_LIGHT_DARK_SURROUNDING = 32] = "BICM_DARK_ON_LIGHT_DARK_SURROUNDING", e[e.BICM_SKIP = 0] = "BICM_SKIP", e[e.BICM_REV = 2147483648] = "BICM_REV";
}(c || (c = {})), function (e) {
  e[e.BCM_AUTO = 1] = "BCM_AUTO", e[e.BCM_GENERAL = 2] = "BCM_GENERAL", e[e.BCM_SKIP = 0] = "BCM_SKIP", e[e.BCM_REV = 2147483648] = "BCM_REV";
}(u || (u = {})), function (e) {
  e[e.BF2_NULL = 0] = "BF2_NULL", e[e.BF2_POSTALCODE = 32505856] = "BF2_POSTALCODE", e[e.BF2_NONSTANDARD_BARCODE = 1] = "BF2_NONSTANDARD_BARCODE", e[e.BF2_USPSINTELLIGENTMAIL = 1048576] = "BF2_USPSINTELLIGENTMAIL", e[e.BF2_POSTNET = 2097152] = "BF2_POSTNET", e[e.BF2_PLANET = 4194304] = "BF2_PLANET", e[e.BF2_AUSTRALIANPOST = 8388608] = "BF2_AUSTRALIANPOST", e[e.BF2_RM4SCC = 16777216] = "BF2_RM4SCC", e[e.BF2_DOTCODE = 2] = "BF2_DOTCODE";
}(h || (h = {})), function (e) {
  e[e.BM_AUTO = 1] = "BM_AUTO", e[e.BM_LOCAL_BLOCK = 2] = "BM_LOCAL_BLOCK", e[e.BM_SKIP = 0] = "BM_SKIP", e[e.BM_THRESHOLD = 4] = "BM_THRESHOLD", e[e.BM_REV = 2147483648] = "BM_REV";
}(g || (g = {})), function (e) {
  e[e.ECCM_CONTRAST = 1] = "ECCM_CONTRAST";
}(R || (R = {})), function (e) {
  e[e.CFM_GENERAL = 1] = "CFM_GENERAL";
}(E || (E = {})), function (e) {
  e[e.CCM_AUTO = 1] = "CCM_AUTO", e[e.CCM_GENERAL_HSV = 2] = "CCM_GENERAL_HSV", e[e.CCM_SKIP = 0] = "CCM_SKIP", e[e.CCM_REV = 2147483648] = "CCM_REV";
}(I || (I = {})), function (e) {
  e[e.CICM_GENERAL = 1] = "CICM_GENERAL", e[e.CICM_SKIP = 0] = "CICM_SKIP", e[e.CICM_REV = 2147483648] = "CICM_REV";
}(A || (A = {})), function (e) {
  e[e.CM_IGNORE = 1] = "CM_IGNORE", e[e.CM_OVERWRITE = 2] = "CM_OVERWRITE";
}(S || (S = {})), function (e) {
  e[e.DM_SKIP = 0] = "DM_SKIP", e[e.DM_DIRECT_BINARIZATION = 1] = "DM_DIRECT_BINARIZATION", e[e.DM_THRESHOLD_BINARIZATION = 2] = "DM_THRESHOLD_BINARIZATION", e[e.DM_GRAY_EQUALIZATION = 4] = "DM_GRAY_EQUALIZATION", e[e.DM_SMOOTHING = 8] = "DM_SMOOTHING", e[e.DM_MORPHING = 16] = "DM_MORPHING", e[e.DM_DEEP_ANALYSIS = 32] = "DM_DEEP_ANALYSIS", e[e.DM_SHARPENING = 64] = "DM_SHARPENING", e[e.DM_BASED_ON_LOC_BIN = 128] = "DM_BASED_ON_LOC_BIN", e[e.DM_SHARPENING_SMOOTHING = 256] = "DM_SHARPENING_SMOOTHING";
}(D || (D = {})), function (e) {
  e[e.DRM_AUTO = 1] = "DRM_AUTO", e[e.DRM_GENERAL = 2] = "DRM_GENERAL", e[e.DRM_SKIP = 0] = "DRM_SKIP", e[e.DRM_REV = 2147483648] = "DRM_REV";
}(f || (f = {})), function (e) {
  e[e.DPMCRM_AUTO = 1] = "DPMCRM_AUTO", e[e.DPMCRM_GENERAL = 2] = "DPMCRM_GENERAL", e[e.DPMCRM_SKIP = 0] = "DPMCRM_SKIP", e[e.DPMCRM_REV = 2147483648] = "DPMCRM_REV";
}(m || (m = {})), function (e) {
  e[e.GTM_INVERTED = 1] = "GTM_INVERTED", e[e.GTM_ORIGINAL = 2] = "GTM_ORIGINAL", e[e.GTM_SKIP = 0] = "GTM_SKIP", e[e.GTM_REV = 2147483648] = "GTM_REV";
}(T || (T = {})), function (e) {
  e[e.IPM_AUTO = 1] = "IPM_AUTO", e[e.IPM_GENERAL = 2] = "IPM_GENERAL", e[e.IPM_GRAY_EQUALIZE = 4] = "IPM_GRAY_EQUALIZE", e[e.IPM_GRAY_SMOOTH = 8] = "IPM_GRAY_SMOOTH", e[e.IPM_SHARPEN_SMOOTH = 16] = "IPM_SHARPEN_SMOOTH", e[e.IPM_MORPHOLOGY = 32] = "IPM_MORPHOLOGY", e[e.IPM_SKIP = 0] = "IPM_SKIP", e[e.IPM_REV = 2147483648] = "IPM_REV";
}(M || (M = {})), function (e) {
  e[e.IRSM_MEMORY = 1] = "IRSM_MEMORY", e[e.IRSM_FILESYSTEM = 2] = "IRSM_FILESYSTEM", e[e.IRSM_BOTH = 4] = "IRSM_BOTH";
}(C || (C = {})), function (e) {
  e[e.IRT_NO_RESULT = 0] = "IRT_NO_RESULT", e[e.IRT_ORIGINAL_IMAGE = 1] = "IRT_ORIGINAL_IMAGE", e[e.IRT_COLOUR_CLUSTERED_IMAGE = 2] = "IRT_COLOUR_CLUSTERED_IMAGE", e[e.IRT_COLOUR_CONVERTED_GRAYSCALE_IMAGE = 4] = "IRT_COLOUR_CONVERTED_GRAYSCALE_IMAGE", e[e.IRT_TRANSFORMED_GRAYSCALE_IMAGE = 8] = "IRT_TRANSFORMED_GRAYSCALE_IMAGE", e[e.IRT_PREDETECTED_REGION = 16] = "IRT_PREDETECTED_REGION", e[e.IRT_PREPROCESSED_IMAGE = 32] = "IRT_PREPROCESSED_IMAGE", e[e.IRT_BINARIZED_IMAGE = 64] = "IRT_BINARIZED_IMAGE", e[e.IRT_TEXT_ZONE = 128] = "IRT_TEXT_ZONE", e[e.IRT_CONTOUR = 256] = "IRT_CONTOUR", e[e.IRT_LINE_SEGMENT = 512] = "IRT_LINE_SEGMENT", e[e.IRT_FORM = 1024] = "IRT_FORM", e[e.IRT_SEGMENTATION_BLOCK = 2048] = "IRT_SEGMENTATION_BLOCK", e[e.IRT_TYPED_BARCODE_ZONE = 4096] = "IRT_TYPED_BARCODE_ZONE", e[e.IRT_PREDETECTED_QUADRILATERAL = 8192] = "IRT_PREDETECTED_QUADRILATERAL";
}(L || (L = {})), function (e) {
  e[e.LM_SKIP = 0] = "LM_SKIP", e[e.LM_AUTO = 1] = "LM_AUTO", e[e.LM_CONNECTED_BLOCKS = 2] = "LM_CONNECTED_BLOCKS", e[e.LM_LINES = 8] = "LM_LINES", e[e.LM_STATISTICS = 4] = "LM_STATISTICS", e[e.LM_SCAN_DIRECTLY = 16] = "LM_SCAN_DIRECTLY", e[e.LM_STATISTICS_MARKS = 32] = "LM_STATISTICS_MARKS", e[e.LM_STATISTICS_POSTAL_CODE = 64] = "LM_STATISTICS_POSTAL_CODE", e[e.LM_CENTRE = 128] = "LM_CENTRE", e[e.LM_ONED_FAST_SCAN = 256] = "LM_ONED_FAST_SCAN", e[e.LM_REV = 2147483648] = "LM_REV";
}(O || (O = {})), function (e) {
  e[e.PDFRM_RASTER = 1] = "PDFRM_RASTER", e[e.PDFRM_AUTO = 2] = "PDFRM_AUTO", e[e.PDFRM_VECTOR = 4] = "PDFRM_VECTOR", e[e.PDFRM_REV = 2147483648] = "PDFRM_REV";
}(N || (N = {})), function (e) {
  e[e.QRECL_ERROR_CORRECTION_H = 0] = "QRECL_ERROR_CORRECTION_H", e[e.QRECL_ERROR_CORRECTION_L = 1] = "QRECL_ERROR_CORRECTION_L", e[e.QRECL_ERROR_CORRECTION_M = 2] = "QRECL_ERROR_CORRECTION_M", e[e.QRECL_ERROR_CORRECTION_Q = 3] = "QRECL_ERROR_CORRECTION_Q";
}(y || (y = {})), function (e) {
  e[e.RPM_AUTO = 1] = "RPM_AUTO", e[e.RPM_GENERAL = 2] = "RPM_GENERAL", e[e.RPM_GENERAL_RGB_CONTRAST = 4] = "RPM_GENERAL_RGB_CONTRAST", e[e.RPM_GENERAL_GRAY_CONTRAST = 8] = "RPM_GENERAL_GRAY_CONTRAST", e[e.RPM_GENERAL_HSV_CONTRAST = 16] = "RPM_GENERAL_HSV_CONTRAST", e[e.RPM_SKIP = 0] = "RPM_SKIP", e[e.RPM_REV = 2147483648] = "RPM_REV";
}(B || (B = {})), function (e) {
  e[e.RCT_PIXEL = 1] = "RCT_PIXEL", e[e.RCT_PERCENTAGE = 2] = "RCT_PERCENTAGE";
}(p || (p = {})), function (e) {
  e[e.RT_STANDARD_TEXT = 0] = "RT_STANDARD_TEXT", e[e.RT_RAW_TEXT = 1] = "RT_RAW_TEXT", e[e.RT_CANDIDATE_TEXT = 2] = "RT_CANDIDATE_TEXT", e[e.RT_PARTIAL_TEXT = 3] = "RT_PARTIAL_TEXT";
}(v || (v = {})), function (e) {
  e[e.SUM_AUTO = 1] = "SUM_AUTO", e[e.SUM_LINEAR_INTERPOLATION = 2] = "SUM_LINEAR_INTERPOLATION", e[e.SUM_NEAREST_NEIGHBOUR_INTERPOLATION = 4] = "SUM_NEAREST_NEIGHBOUR_INTERPOLATION", e[e.SUM_SKIP = 0] = "SUM_SKIP", e[e.SUM_REV = 2147483648] = "SUM_REV";
}(b || (b = {})), function (e) {
  e[e.TP_REGION_PREDETECTED = 1] = "TP_REGION_PREDETECTED", e[e.TP_IMAGE_PREPROCESSED = 2] = "TP_IMAGE_PREPROCESSED", e[e.TP_IMAGE_BINARIZED = 4] = "TP_IMAGE_BINARIZED", e[e.TP_BARCODE_LOCALIZED = 8] = "TP_BARCODE_LOCALIZED", e[e.TP_BARCODE_TYPE_DETERMINED = 16] = "TP_BARCODE_TYPE_DETERMINED", e[e.TP_BARCODE_RECOGNIZED = 32] = "TP_BARCODE_RECOGNIZED";
}(F || (F = {})), function (e) {
  e[e.TFM_AUTO = 1] = "TFM_AUTO", e[e.TFM_GENERAL_CONTOUR = 2] = "TFM_GENERAL_CONTOUR", e[e.TFM_SKIP = 0] = "TFM_SKIP", e[e.TFM_REV = 2147483648] = "TFM_REV";
}(P || (P = {})), function (e) {
  e[e.TROM_CONFIDENCE = 1] = "TROM_CONFIDENCE", e[e.TROM_POSITION = 2] = "TROM_POSITION", e[e.TROM_FORMAT = 4] = "TROM_FORMAT", e[e.TROM_SKIP = 0] = "TROM_SKIP", e[e.TROM_REV = 2147483648] = "TROM_REV";
}(w || (w = {})), function (e) {
  e[e.TDM_AUTO = 1] = "TDM_AUTO", e[e.TDM_GENERAL_WIDTH_CONCENTRATION = 2] = "TDM_GENERAL_WIDTH_CONCENTRATION", e[e.TDM_SKIP = 0] = "TDM_SKIP", e[e.TDM_REV = 2147483648] = "TDM_REV";
}(V || (V = {}));

var U = /*#__PURE__*/function () {
  function U() {
    _classCallCheck(this, U);
  }

  _createClass(U, null, [{
    key: "detectEnvironment",
    value: function detectEnvironment() {
      return _.detectEnvironment();
    }
  }, {
    key: "isLoaded",
    value: function isLoaded() {
      return _.isLoaded();
    }
  }, {
    key: "isWasmLoaded",
    value: function isWasmLoaded() {
      return _.isLoaded();
    }
  }, {
    key: "loadWasm",
    value: function loadWasm() {
      return _.loadWasm();
    }
  }, {
    key: "version",
    get: function get() {
      return _.version;
    }
  }, {
    key: "productKeys",
    get: function get() {
      return _.productKeys;
    },
    set: function set(e) {
      _.productKeys = e;
    }
  }, {
    key: "handshakeCode",
    get: function get() {
      return _.handshakeCode;
    },
    set: function set(e) {
      _.handshakeCode = e;
    }
  }, {
    key: "organizationID",
    get: function get() {
      return _.organizationID;
    },
    set: function set(e) {
      _.organizationID = e;
    }
  }, {
    key: "sessionPassword",
    get: function get() {
      return _.sessionPassword;
    },
    set: function set(e) {
      _.sessionPassword = e;
    }
  }, {
    key: "browserInfo",
    get: function get() {
      return _.browserInfo;
    }
  }, {
    key: "_workerName",
    get: function get() {
      return _._workerName;
    },
    set: function set(e) {
      _._workerName = e;
    }
  }, {
    key: "engineResourcePath",
    get: function get() {
      return _.engineResourcePath;
    },
    set: function set(e) {
      _.engineResourcePath = e;
    }
  }, {
    key: "licenseServer",
    get: function get() {
      return _.licenseServer;
    },
    set: function set(e) {
      _.licenseServer = e;
    }
  }, {
    key: "deviceFriendlyName",
    get: function get() {
      return _.deviceFriendlyName;
    },
    set: function set(e) {
      _.deviceFriendlyName = e;
    }
  }, {
    key: "_onLog",
    get: function get() {
      return _._onLog;
    },
    set: function set(e) {
      _._onLog = e;
    }
  }, {
    key: "_bWasmDebug",
    get: function get() {
      return _._bWasmDebug;
    },
    set: function set(e) {
      _._bWasmDebug = e;
    }
  }, {
    key: "_bUseFullFeature",
    get: function get() {
      return _._bUseFullFeature;
    },
    set: function set(e) {
      _._bUseFullFeature = e;
    }
  }, {
    key: "_dbrWorker",
    get: function get() {
      return _._dbrWorker;
    }
  }]);

  return U;
}();

U.DBR = U, U.BarcodeReader = _, U.BarcodeScanner = l, U.CameraEnhancer = e, U.EnumBarcodeColourMode = c, U.EnumBarcodeComplementMode = u, U.EnumBarcodeFormat = o, U.EnumBarcodeFormat_2 = h, U.EnumBinarizationMode = g, U.EnumClarityCalculationMethod = R, U.EnumClarityFilterMode = E, U.EnumColourClusteringMode = I, U.EnumColourConversionMode = A, U.EnumConflictMode = S, U.EnumDeblurMode = D, U.EnumDeformationResistingMode = f, U.EnumDPMCodeReadingMode = m, U.EnumErrorCode = r, U.EnumGrayscaleTransformationMode = T, U.EnumImagePixelFormat = n, U.EnumImagePreprocessingMode = M, U.EnumIMResultDataType = s, U.EnumIntermediateResultSavingMode = C, U.EnumIntermediateResultType = L, U.EnumLocalizationMode = O, U.EnumPDFReadingMode = N, U.EnumQRCodeErrorCorrectionLevel = y, U.EnumRegionPredetectionMode = B, U.EnumResultCoordinateType = p, U.EnumResultType = v, U.EnumScaleUpMode = b, U.EnumTerminatePhase = F, U.EnumTextFilterMode = P, U.EnumTextResultOrderMode = w, U.EnumTextureDetectionMode = V;
export { _ as BarcodeReader, l as BarcodeScanner, U as DBR, c as EnumBarcodeColourMode, u as EnumBarcodeComplementMode, o as EnumBarcodeFormat, h as EnumBarcodeFormat_2, g as EnumBinarizationMode, R as EnumClarityCalculationMethod, E as EnumClarityFilterMode, I as EnumColourClusteringMode, A as EnumColourConversionMode, S as EnumConflictMode, m as EnumDPMCodeReadingMode, D as EnumDeblurMode, f as EnumDeformationResistingMode, r as EnumErrorCode, T as EnumGrayscaleTransformationMode, s as EnumIMResultDataType, n as EnumImagePixelFormat, M as EnumImagePreprocessingMode, C as EnumIntermediateResultSavingMode, L as EnumIntermediateResultType, O as EnumLocalizationMode, N as EnumPDFReadingMode, y as EnumQRCodeErrorCorrectionLevel, B as EnumRegionPredetectionMode, p as EnumResultCoordinateType, v as EnumResultType, b as EnumScaleUpMode, F as EnumTerminatePhase, P as EnumTextFilterMode, w as EnumTextResultOrderMode, V as EnumTextureDetectionMode, U as default };